// Inline text effects for blog prose. Markdown wraps a phrase in
// <span data-fx="name">; the phrase gets class `is-on` once it scrolls into
// view and plays once. Every effect ends in a readable resting state, and
// without JS the phrase is plain text.
const $d1367d94205577f3$var$reduced = ()=>window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $d1367d94205577f3$var$sleep = (ms)=>new Promise((r)=>setTimeout(r, ms));
function $d1367d94205577f3$var$append(el, cls, html = "") {
    const s = document.createElement("span");
    s.className = cls;
    s.setAttribute("aria-hidden", "true");
    s.innerHTML = html;
    el.append(s);
    return s;
}
const $d1367d94205577f3$var$AGENT_STEPS = [
    [
        "reading upload_client.py",
        480
    ],
    [
        "editing upload_client.py (+6 \u22120)",
        560
    ],
    [
        "editing config/prod.yaml (+1 \u22121)",
        480
    ],
    [
        "pytest \xb7 1 failed (422 != 200)",
        580
    ],
    [
        "editing test_upload.py (+1 \u22121)",
        520
    ],
    [
        "pytest \xb7 14 passed",
        440
    ]
];
const $d1367d94205577f3$var$FINAL_STATUS = "<b>\u2713 fix/upload-retries</b> \xb7 3 files (+8 \u22122) \xb7 tests pass";
// Built before the phrase is seen, so the reveal does not reflow the line.
const $d1367d94205577f3$var$prepare = {
    bar: (el)=>{
        const from = Number(el.dataset.from ?? 100);
        const to = Number(el.dataset.to ?? 100);
        const max = Math.max(from, to);
        const bar = $d1367d94205577f3$var$append(el, `fx-bar ${to < from ? "is-down" : "is-up"}`, '<i class="fx-bar__old"></i><i class="fx-bar__new"></i>');
        bar.style.setProperty("--from", `${from / max * 100}%`);
        bar.style.setProperty("--from-k", String(from / max));
        bar.style.setProperty("--to-k", String(to / max));
    },
    fill: (el)=>{
        const m = $d1367d94205577f3$var$append(el, "fx-meter", "<i></i>");
        m.style.setProperty("--to-k", String(Number(el.dataset.to ?? 90) / 100));
    },
    spike: (el)=>{
        $d1367d94205577f3$var$append(el, "fx-spark", '<svg viewBox="0 0 60 16" preserveAspectRatio="none"><path class="fx-spark__base" d="M1 12 L8 11.5 L15 12.4 L22 11.2 L29 12 L36 11.6 L41 12.2" /><path class="fx-spark__hot" d="M41 12.2 L46 11 L50 2.5 L54 9 L59 7" /><circle cx="50" cy="2.5" r="1.8" /></svg>');
    },
    type: (el)=>{
        const text = el.textContent ?? "";
        el.setAttribute("aria-label", text);
        el.dataset.text = text;
        el.innerHTML = '<div class="fx-term__row"><span class="fx-term__sig" aria-hidden="true">&gt;</span><span class="fx-term__body" aria-hidden="true">' + `<span class="fx-term__txt">${text}</span>` + '<i class="fx-term__cur"></i>' + '<span class="fx-term__ghost"></span>' + "</span>" + '<button type="button" class="fx-term__send" aria-label="Send prompt to agent">' + '<span class="fx-term__send-lbl">send</span><kbd>\u21B5</kbd>' + "</button>" + "</div>" + '<div class="fx-term__status" role="status" aria-live="polite">' + '<i class="fx-term__dot" aria-hidden="true"></i>' + '<span class="fx-term__msg">ready \xb7 click send <kbd>\u21B5</kbd></span>' + "</div>";
        const btn = el.querySelector(".fx-term__send");
        const msg = el.querySelector(".fx-term__msg");
        const lbl = el.querySelector(".fx-term__send-lbl");
        const txt = el.querySelector(".fx-term__txt");
        const ghost = el.querySelector(".fx-term__ghost");
        let runToken = 0;
        const runAgent = async ()=>{
            const my = ++runToken;
            txt.textContent = text;
            ghost.textContent = "";
            el.classList.add("is-done", "is-running");
            el.classList.remove("is-branch");
            lbl.textContent = "running";
            if ($d1367d94205577f3$var$reduced()) {
                el.classList.remove("is-running");
                el.classList.add("is-branch");
                lbl.textContent = "rerun";
                msg.innerHTML = $d1367d94205577f3$var$FINAL_STATUS;
                return;
            }
            for (const [step, ms] of $d1367d94205577f3$var$AGENT_STEPS){
                if (my !== runToken) return;
                msg.textContent = step;
                await $d1367d94205577f3$var$sleep(ms);
            }
            if (my !== runToken) return;
            el.classList.remove("is-running");
            el.classList.add("is-branch");
            lbl.textContent = "rerun";
            msg.innerHTML = $d1367d94205577f3$var$FINAL_STATUS;
        };
        btn.addEventListener("click", ()=>void runAgent());
    }
};
// Run when the phrase is seen.
const $d1367d94205577f3$var$play = {
    type: (el)=>{
        const text = el.dataset.text ?? "";
        const txt = el.querySelector(".fx-term__txt");
        const ghost = el.querySelector(".fx-term__ghost");
        if (!txt || !ghost || el.classList.contains("is-running") || el.classList.contains("is-branch")) return;
        txt.textContent = "";
        ghost.textContent = text;
        (async ()=>{
            for(let i = 0; i <= text.length; i++){
                if (el.classList.contains("is-running") || el.classList.contains("is-branch")) return;
                txt.textContent = text.slice(0, i);
                ghost.textContent = text.slice(i);
                await $d1367d94205577f3$var$sleep(34 + Math.random() * 20);
            }
            el.classList.add("is-done");
        })();
    },
    count: (el)=>{
        const to = Number(el.dataset.to ?? el.textContent);
        const t0 = performance.now();
        const frame = ()=>{
            const k = Math.min(1, (performance.now() - t0) / 1700);
            el.textContent = String(Math.round(to * (1 - Math.pow(1 - k, 3))));
            if (k < 1) requestAnimationFrame(frame);
        };
        frame();
    }
};
function $d1367d94205577f3$export$5dd9ba22cea632f5(root = document) {
    const els = Array.from(root.querySelectorAll("[data-fx]"));
    if (els.length === 0) return;
    const still = $d1367d94205577f3$var$reduced();
    els.forEach((el)=>$d1367d94205577f3$var$prepare[el.dataset.fx ?? ""]?.(el));
    const activate = (el)=>{
        el.classList.add("is-on");
        if (!still) $d1367d94205577f3$var$play[el.dataset.fx ?? ""]?.(el);
    };
    if (still || !("IntersectionObserver" in window)) {
        els.forEach(activate);
        return;
    }
    // Phrases in one paragraph play in reading order instead of all at once.
    const nextFree = new Map();
    const io = new IntersectionObserver((entries)=>{
        entries.forEach((e)=>{
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            const el = e.target;
            const block = el.closest("p, li, blockquote, aside");
            const now = performance.now();
            const at = Math.max(now, nextFree.get(block) ?? 0);
            nextFree.set(block, at + 320);
            setTimeout(()=>activate(el), at - now);
        });
    }, {
        rootMargin: "0px 0px -18% 0px",
        threshold: 0.6
    });
    els.forEach((el)=>io.observe(el));
}


const $5c38d4c8775354e7$export$c7559910573e9368 = ()=>window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $5c38d4c8775354e7$export$e772c8ff12451969 = (ms)=>new Promise((r)=>setTimeout(r, ms));
function $5c38d4c8775354e7$export$dda1d9f60106f0e9(tag, cls = "", text) {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text !== undefined) el.textContent = text;
    return el;
}
const $5c38d4c8775354e7$var$SVG_NS = "http://www.w3.org/2000/svg";
function $5c38d4c8775354e7$export$2408f22a0fab9ae5(tag, attrs = {}) {
    const el = document.createElementNS($5c38d4c8775354e7$var$SVG_NS, tag);
    for (const [k, v] of Object.entries(attrs))el.setAttribute(k, String(v));
    return el;
}
function $5c38d4c8775354e7$export$36a0c1ca2ae264fa(el, cb, ratio = 0.35) {
    if (!("IntersectionObserver" in window)) {
        cb(true);
        return;
    }
    new IntersectionObserver((es)=>es.forEach((e)=>cb(e.isIntersecting)), {
        threshold: ratio
    }).observe(el);
}
function $5c38d4c8775354e7$export$d16895a5a96f4(el, start = 0.85, end = 0.2) {
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight;
    const k = (vh * start - r.top) / (vh * (start - end));
    return Math.min(1, Math.max(0, k));
}
function $5c38d4c8775354e7$export$8b4981022bd80a4e(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(`--fx-${name}`).trim();
}
function $5c38d4c8775354e7$export$975941c9c4dbfcc8() {
    return {
        tx: $5c38d4c8775354e7$export$8b4981022bd80a4e("tx") || "#100f0f",
        tx2: $5c38d4c8775354e7$export$8b4981022bd80a4e("tx2") || "#6f6e69",
        tx3: $5c38d4c8775354e7$export$8b4981022bd80a4e("tx3") || "#b7b5ac",
        ui: $5c38d4c8775354e7$export$8b4981022bd80a4e("ui") || "#e6e4d9",
        bg: $5c38d4c8775354e7$export$8b4981022bd80a4e("bg") || "#fffcf0",
        bg2: $5c38d4c8775354e7$export$8b4981022bd80a4e("bg2") || "#f2f0e5",
        green: $5c38d4c8775354e7$export$8b4981022bd80a4e("green") || "#66800b",
        red: $5c38d4c8775354e7$export$8b4981022bd80a4e("red") || "#af3029"
    };
}
function $5c38d4c8775354e7$export$5c03d20f483e909a(seed) {
    let a = seed >>> 0;
    return ()=>{
        a = a + 0x6d2b79f5 >>> 0;
        let t = a;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
const $5c38d4c8775354e7$export$7d15b64cf5a3a4c4 = (v, lo = 0, hi = 1)=>Math.min(hi, Math.max(lo, v));
const $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f = (a, b, t)=>a + (b - a) * t;
const $5c38d4c8775354e7$export$1157fb72e7fbceb5 = (x)=>1 - Math.pow(1 - $5c38d4c8775354e7$export$7d15b64cf5a3a4c4(x), 3);
const $5c38d4c8775354e7$export$24656b269d8df7d6 = (x)=>{
    const t = $5c38d4c8775354e7$export$7d15b64cf5a3a4c4(x);
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
};
function $5c38d4c8775354e7$export$d1f8fcb84651afa9(initial) {
    const sp = {
        val: initial,
        vel: 0,
        target: initial,
        step (dt, stiffness = 170, damping = 22) {
            const d = Math.min(dt, 0.05);
            const f = -stiffness * (sp.val - sp.target) - damping * sp.vel;
            sp.vel += f * d;
            sp.val += sp.vel * d;
            return sp.val;
        },
        snap (v) {
            sp.val = v;
            sp.target = v;
            sp.vel = 0;
        }
    };
    return sp;
}
function $5c38d4c8775354e7$export$bb1011bf29bdb8a7(ctx, W, H, c, step = 28) {
    ctx.save();
    ctx.fillStyle = c.tx3;
    ctx.globalAlpha = 0.22;
    const ox = W % step * 0.5;
    const oy = H % step * 0.5;
    for(let x = ox; x < W; x += step)for(let y = oy; y < H; y += step)ctx.fillRect(Math.round(x), Math.round(y), 1, 1);
    // 4 corner reticles
    ctx.strokeStyle = c.tx3;
    ctx.globalAlpha = 0.45;
    ctx.lineWidth = 1;
    const m = 8;
    const len = 6;
    const corners = [
        [
            m,
            m,
            1,
            1
        ],
        [
            W - m,
            m,
            -1,
            1
        ],
        [
            m,
            H - m,
            1,
            -1
        ],
        [
            W - m,
            H - m,
            -1,
            -1
        ]
    ];
    ctx.beginPath();
    for (const [cx, cy, dx, dy] of corners){
        ctx.moveTo(cx, cy + dy * len);
        ctx.lineTo(cx, cy);
        ctx.lineTo(cx + dx * len, cy);
    }
    ctx.stroke();
    ctx.restore();
}
function $5c38d4c8775354e7$export$46dda4462911a727(ctx, x, y, r, color, haloAlpha = 0.2, haloScale = 2.6) {
    ctx.save();
    if (haloAlpha > 0.01) {
        ctx.fillStyle = color;
        ctx.globalAlpha = haloAlpha;
        ctx.beginPath();
        ctx.arc(x, y, r * haloScale, 0, Math.PI * 2);
        ctx.fill();
    }
    ctx.fillStyle = color;
    ctx.globalAlpha = 1;
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
}
function $5c38d4c8775354e7$export$7ac3698ce9457404(ctx, text, x, y, fg, bg, border, align = "center") {
    ctx.save();
    ctx.font = `500 10px 'Geist Pixel', ui-monospace, monospace`;
    const m = ctx.measureText(text);
    const pw = m.width + 12;
    const ph = 17;
    const rx = align === "left" ? x : align === "right" ? x - pw : x - pw * 0.5;
    const ry = y - ph * 0.5 - 1;
    ctx.fillStyle = bg;
    ctx.globalAlpha = 0.92;
    ctx.beginPath();
    ctx.roundRect(rx, ry, pw, ph, 3.5);
    ctx.fill();
    ctx.strokeStyle = border;
    ctx.globalAlpha = 0.55;
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.fillStyle = fg;
    ctx.globalAlpha = 1;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(text, rx + pw * 0.5, ry + ph * 0.5 + 0.5);
    ctx.restore();
}
function $5c38d4c8775354e7$export$a629db21b6497626(stage, heightFn, drawFn, animated = true) {
    const canvas = $5c38d4c8775354e7$export$dda1d9f60106f0e9("canvas", "fxv-canvas");
    canvas.setAttribute("aria-hidden", "true");
    stage.prepend(canvas);
    const ctx = canvas.getContext("2d");
    let W = 0;
    let H = 0;
    let cols = $5c38d4c8775354e7$export$975941c9c4dbfcc8();
    let raf = 0;
    let visible = false;
    const t0 = performance.now();
    let lastT = t0;
    const pointer = {
        x: 0.5,
        y: 0.5,
        inside: false,
        down: false
    };
    const resize = ()=>{
        const dpr = Math.min(2, window.devicePixelRatio || 1);
        W = Math.max(260, stage.clientWidth || 680);
        H = heightFn(W);
        canvas.width = Math.round(W * dpr);
        canvas.height = Math.round(H * dpr);
        canvas.style.width = `${W}px`;
        canvas.style.height = `${H}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        cols = $5c38d4c8775354e7$export$975941c9c4dbfcc8();
    };
    const paint = (now = performance.now())=>{
        if (!W) resize();
        const dt = Math.min(0.05, Math.max(0.001, (now - lastT) * 0.001));
        lastT = now;
        $5c38d4c8775354e7$export$bb1011bf29bdb8a7(ctx, W, H, cols);
        drawFn(ctx, W, H, cols, (now - t0) * 0.001, dt, pointer);
    };
    const loop = (now)=>{
        if (!visible) {
            raf = 0;
            return;
        }
        paint(now);
        raf = requestAnimationFrame(loop);
    };
    const updatePointer = (e)=>{
        const rect = canvas.getBoundingClientRect();
        pointer.x = $5c38d4c8775354e7$export$7d15b64cf5a3a4c4((e.clientX - rect.left) / Math.max(1, rect.width));
        pointer.y = $5c38d4c8775354e7$export$7d15b64cf5a3a4c4((e.clientY - rect.top) / Math.max(1, rect.height));
    };
    stage.addEventListener("pointerenter", (e)=>{
        pointer.inside = true;
        updatePointer(e);
    });
    stage.addEventListener("pointermove", (e)=>{
        pointer.inside = true;
        updatePointer(e);
    });
    stage.addEventListener("pointerleave", ()=>{
        pointer.inside = false;
        pointer.down = false;
    });
    stage.addEventListener("pointerdown", (e)=>{
        pointer.down = true;
        updatePointer(e);
    });
    window.addEventListener("pointerup", ()=>{
        pointer.down = false;
    });
    resize();
    paint();
    new ResizeObserver(()=>{
        resize();
        paint();
    }).observe(stage);
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ()=>{
        cols = $5c38d4c8775354e7$export$975941c9c4dbfcc8();
        paint();
    });
    if (animated && !$5c38d4c8775354e7$export$c7559910573e9368()) $5c38d4c8775354e7$export$36a0c1ca2ae264fa(stage, (on)=>{
        visible = on;
        if (on && !raf) {
            lastT = performance.now();
            raf = requestAnimationFrame(loop);
        }
        if (!on && raf) {
            cancelAnimationFrame(raf);
            raf = 0;
        }
    }, 0.08);
    return {
        canvas: canvas,
        ctx: ctx,
        width: ()=>W,
        height: ()=>H,
        colors: ()=>cols,
        pointer: pointer,
        redraw: ()=>paint()
    };
}


// Fig. 3 (cut): Trajectory divergence & the 5 shear cuts.
const $b490805aa5bd5c06$var$CUTS = [
    {
        x: 0.24,
        ay: 0.34,
        hy: 0.63,
        sym: "\u2715",
        a: "\u2265400",
        b: "\u2265500"
    },
    {
        x: 0.41,
        ay: 0.25,
        hy: 0.67,
        sym: "\u270E",
        a: "2**n",
        b: "jitter"
    },
    {
        x: 0.58,
        ay: 0.19,
        hy: 0.69,
        sym: "\u21BA",
        a: "300s",
        b: "30s"
    },
    {
        x: 0.74,
        ay: 0.15,
        hy: 0.71,
        sym: "\u21BA",
        a: "200|422",
        b: "422"
    },
    {
        x: 0.89,
        ay: 0.12,
        hy: 0.72,
        sym: "\u25A0",
        a: "run #2",
        b: "SIGKILL"
    }
];
function $b490805aa5bd5c06$export$f468e077dafd7866(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    let active = 0;
    let userMoved = false;
    const focusSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0);
    const ctrl = (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 220 : 250, (ctx, W, H, c, t, dt, pointer)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        if (pointer.inside) {
            userMoved = true;
            let best = 0;
            let bestD = 99;
            $b490805aa5bd5c06$var$CUTS.forEach((k, i)=>{
                const d = Math.abs(k.x - pointer.x);
                if (d < bestD) {
                    bestD = d;
                    best = i;
                }
            });
            active = best;
        } else if (!userMoved) active = Math.floor(t * 0.5) % $b490805aa5bd5c06$var$CUTS.length;
        focusSp.target = active;
        const focusIdx = focusSp.step(dt, 180, 22);
        const ox = W * 0.08;
        const oy = H * 0.56;
        const endX = W * 0.94;
        const aPts = [
            [
                ox,
                oy
            ],
            ...$b490805aa5bd5c06$var$CUTS.map((k)=>[
                    k.x * W,
                    k.ay * H
                ]),
            [
                endX,
                H * 0.11
            ]
        ];
        const hPts = [
            [
                ox,
                oy
            ],
            ...$b490805aa5bd5c06$var$CUTS.map((k)=>[
                    k.x * W,
                    k.hy * H
                ]),
            [
                endX,
                H * 0.72
            ]
        ];
        const traceCurve = (pts)=>{
            ctx.moveTo(pts[0][0], pts[0][1]);
            for(let i = 0; i < pts.length - 1; i++){
                const [x0, y0] = pts[i];
                const [x1, y1] = pts[i + 1];
                const mx = (x0 + x1) * 0.5;
                ctx.bezierCurveTo(mx, y0, mx, y1, x1, y1);
            }
        };
        // Shaded correction delta wedge with diagonal hatch lines
        ctx.save();
        ctx.beginPath();
        traceCurve(aPts);
        for(let i = hPts.length - 1; i >= 0; i--)ctx.lineTo(hPts[i][0], hPts[i][1]);
        ctx.closePath();
        ctx.fillStyle = c.red;
        ctx.globalAlpha = 0.07;
        ctx.fill();
        ctx.clip();
        ctx.strokeStyle = c.red;
        ctx.globalAlpha = 0.14;
        ctx.lineWidth = 1;
        for(let x = -H; x < W + H; x += 11){
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x + H, H);
            ctx.stroke();
        }
        ctx.restore();
        // Agent curve (dashed red)
        ctx.strokeStyle = c.red;
        ctx.globalAlpha = 0.75;
        ctx.lineWidth = 1.6;
        ctx.setLineDash([
            4,
            4
        ]);
        ctx.beginPath();
        traceCurve(aPts);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.globalAlpha = 1;
        // Human curve (solid green + subtle underglow)
        ctx.strokeStyle = c.green;
        ctx.globalAlpha = 0.18;
        ctx.lineWidth = 6;
        ctx.beginPath();
        traceCurve(hPts);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.lineWidth = 2.4;
        ctx.beginPath();
        traceCurve(hPts);
        ctx.stroke();
        // 5 vertical shear cuts
        $b490805aa5bd5c06$var$CUTS.forEach((k, i)=>{
            const x = k.x * W;
            const ay = k.ay * H;
            const hy = k.hy * H;
            const prox = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(1 - Math.abs(focusIdx - i));
            ctx.strokeStyle = prox > 0.5 ? c.tx : c.tx3;
            ctx.globalAlpha = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(0.32, 0.95, prox);
            ctx.lineWidth = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(1, 1.8, prox);
            ctx.beginPath();
            ctx.moveTo(x, ay);
            ctx.lineTo(x, hy);
            ctx.stroke();
            ctx.globalAlpha = 1;
            (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, x, ay, (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(2.8, 4.5, prox), c.red, prox * 0.25, 2.8);
            (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, x, hy, (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(3.2, 5.2, prox), c.green, prox * 0.3, 2.8);
            ctx.font = `500 ${Math.round((0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(10, 12, prox))}px 'Geist Pixel', monospace`;
            ctx.textAlign = "center";
            ctx.fillStyle = prox > 0.5 ? c.tx : c.tx2;
            ctx.fillText(k.sym, x, hy + 18);
            if (i === active) {
                (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, `-${k.a}`, x, ay - 16, c.red, c.bg, c.red, "center");
                (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, `+${k.b}`, x, hy + 34, c.green, c.bg, c.green, "center");
            }
        });
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, ox, oy, 5, c.tx, 0.18, 2.5);
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "prompt", ox + 4, oy - 18, c.tx2, c.bg, c.ui, "left");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "agent", endX, H * 0.11 - 12, c.red, c.bg, c.red, "right");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "you", endX, H * 0.72 - 14, c.green, c.bg, c.green, "right");
    });
    stage.style.cursor = "crosshair";
    stage.addEventListener("click", (e)=>{
        const rect = ctrl.canvas.getBoundingClientRect();
        const nx = (e.clientX - rect.left) / Math.max(1, rect.width);
        let best = 0;
        let bestD = 99;
        $b490805aa5bd5c06$var$CUTS.forEach((k, i)=>{
            const d = Math.abs(k.x - nx);
            if (d < bestD) {
                bestD = d;
                best = i;
            }
        });
        userMoved = true;
        active = best;
        ctrl.redraw();
    });
}



const $6a0c9221858f39e0$var$KINDS = [
    [
        "accept",
        0.34
    ],
    [
        "reject",
        0.22
    ],
    [
        "edit",
        0.2
    ],
    [
        "revert",
        0.14
    ],
    [
        "stop",
        0.1
    ]
];
const $6a0c9221858f39e0$var$TRAVEL_MS = 1700;
const $6a0c9221858f39e0$var$EMIT_MS = 300;
const $6a0c9221858f39e0$var$SAMPLES = 120;
function $6a0c9221858f39e0$var$pickKind(r) {
    let acc = 0;
    for (const [k, p] of $6a0c9221858f39e0$var$KINDS){
        acc += p;
        if (r < acc) return k;
    }
    return "accept";
}
function $6a0c9221858f39e0$export$18c5b31298e7b8db(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxf");
    const svg = (0, $5c38d4c8775354e7$export$2408f22a0fab9ae5)("svg", {
        class: "fxf-svg",
        "aria-hidden": "true"
    });
    const paths = {
        vendor: (0, $5c38d4c8775354e7$export$2408f22a0fab9ae5)("path", {
            class: "fxf-pipe"
        }),
        employer: (0, $5c38d4c8775354e7$export$2408f22a0fab9ae5)("path", {
            class: "fxf-pipe"
        }),
        harness: (0, $5c38d4c8775354e7$export$2408f22a0fab9ae5)("path", {
            class: "fxf-pipe is-harness"
        })
    };
    Object.values(paths).forEach((p)=>svg.append(p));
    const dots = (0, $5c38d4c8775354e7$export$2408f22a0fab9ae5)("g");
    svg.append(dots);
    const node = (cls, title)=>{
        const el = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", `fxf-node ${cls}`);
        el.append((0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxf-node__title", title));
        const c = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxf-node__count");
        c.innerHTML = "<b>0</b>";
        el.append(c);
        return el;
    };
    const you = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxf-node fxf-you");
    you.append((0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxf-node__title", "you"));
    const vendor = node("fxf-sink is-vendor", "vendor");
    const employer = node("fxf-sink is-employer", "employer");
    const harness = node("fxf-sink is-harness", "yours");
    const toggle = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxf-toggle");
    toggle.type = "button";
    toggle.setAttribute("role", "switch");
    toggle.innerHTML = '<span class="fxf-toggle__track"><i></i></span><span class="fxf-toggle__label">local</span>';
    stage.append(svg, you, vendor, employer, harness, toggle);
    fig.prepend(stage);
    const counts = {
        vendor: 0,
        employer: 0,
        harness: 0
    };
    let corrections = 0;
    let local = false;
    let touched = false;
    let visible = false;
    let raf = 0;
    let lastEmit = 0;
    let particles = [];
    let seed = 7;
    const rand = ()=>{
        seed = seed * 16807 % 2147483647;
        return seed / 2147483647;
    };
    let colors = {
        red: "",
        green: "",
        tx: ""
    };
    const routes = {};
    const setCount = (sink)=>{
        const el = ({
            vendor: vendor,
            employer: employer,
            harness: harness
        })[sink].querySelector("b");
        el.textContent = counts[sink].toLocaleString("en-US");
    };
    const setLocal = (on)=>{
        local = on;
        stage.classList.toggle("is-local", on);
        toggle.setAttribute("aria-checked", String(on));
    };
    setLocal(false);
    toggle.addEventListener("click", ()=>{
        touched = true;
        setLocal(!local);
    });
    const layout = ()=>{
        const W = stage.clientWidth || 680;
        const narrow = W < 560;
        const H = narrow ? 280 : 250;
        stage.style.height = `${H}px`;
        svg.setAttribute("viewBox", `0 0 ${W} ${H}`);
        svg.setAttribute("width", String(W));
        svg.setAttribute("height", String(H));
        const youW = 68;
        const sinkW = narrow ? 110 : 140;
        const sinkH = 52;
        const yMid = H / 2 - 12;
        const ys = [
            H * 0.2,
            yMid,
            H * 0.8 - 18
        ];
        you.style.cssText = `left:${narrow ? 12 : 22}px; top:${yMid - 20}px; width:${youW}px;`;
        const sx = W - sinkW - (narrow ? 12 : 22);
        [
            vendor,
            employer,
            harness
        ].forEach((el, i)=>{
            el.style.cssText = `left:${sx}px; top:${ys[i] - sinkH / 2}px; width:${sinkW}px; min-height:${sinkH}px;`;
        });
        const x0 = (narrow ? 12 : 22) + youW;
        [
            "vendor",
            "employer",
            "harness"
        ].forEach((k, i)=>{
            const y1 = ys[i];
            const mx = (x0 + sx) / 2;
            paths[k].setAttribute("d", `M ${x0} ${yMid} C ${mx} ${yMid}, ${mx} ${y1}, ${sx} ${y1}`);
            const len = paths[k].getTotalLength();
            const pts = new Float32Array(($6a0c9221858f39e0$var$SAMPLES + 1) * 2);
            for(let j = 0; j <= $6a0c9221858f39e0$var$SAMPLES; j++){
                const pt = paths[k].getPointAtLength(len * j / $6a0c9221858f39e0$var$SAMPLES);
                pts[j * 2] = pt.x;
                pts[j * 2 + 1] = pt.y;
            }
            routes[k] = pts;
        });
    };
    const emit = (now)=>{
        const kind = $6a0c9221858f39e0$var$pickKind(rand());
        const sinks = local ? [
            "vendor",
            "employer",
            "harness"
        ] : [
            "vendor",
            "employer"
        ];
        const color = kind === "accept" ? colors.tx : kind === "edit" ? colors.green : colors.red;
        sinks.forEach((sink, i)=>{
            const el = (0, $5c38d4c8775354e7$export$2408f22a0fab9ae5)("rect", {
                width: 6,
                height: 6,
                x: -3,
                y: -3,
                fill: color,
                opacity: 0
            });
            dots.append(el);
            particles.push({
                el: el,
                route: routes[sink],
                t0: now + i * 40,
                sink: sink,
                kind: kind
            });
        });
    };
    const arrive = (p)=>{
        if (p.sink !== "harness") counts[p.sink]++;
        else if (p.kind !== "accept") {
            corrections++;
            if (corrections % 3 === 0) {
                counts.harness++;
                harness.classList.remove("is-ping");
                harness.offsetWidth;
                harness.classList.add("is-ping");
            }
        }
        setCount(p.sink);
    };
    let lastFrame = 0;
    const tick = (now)=>{
        raf = requestAnimationFrame(tick);
        if (now - lastFrame < 32) return;
        lastFrame = now;
        if (now - lastEmit > $6a0c9221858f39e0$var$EMIT_MS) {
            lastEmit = now;
            emit(now);
        }
        particles = particles.filter((p)=>{
            const k = (now - p.t0) / $6a0c9221858f39e0$var$TRAVEL_MS;
            if (k < 0) return true;
            if (k >= 1) {
                arrive(p);
                p.el.remove();
                return false;
            }
            const e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
            const i = Math.round(e * $6a0c9221858f39e0$var$SAMPLES) * 2;
            p.el.setAttribute("transform", `translate(${p.route[i].toFixed(1)} ${p.route[i + 1].toFixed(1)})`);
            p.el.setAttribute("opacity", String(Math.min(1, k * 6, (1 - k) * 8)));
            return true;
        });
    };
    const start = ()=>{
        if (raf || (0, $5c38d4c8775354e7$export$c7559910573e9368)()) return;
        colors = {
            red: (0, $5c38d4c8775354e7$export$8b4981022bd80a4e)("red"),
            green: (0, $5c38d4c8775354e7$export$8b4981022bd80a4e)("green"),
            tx: (0, $5c38d4c8775354e7$export$8b4981022bd80a4e)("tx3")
        };
        raf = requestAnimationFrame(tick);
    };
    const stop = ()=>{
        cancelAnimationFrame(raf);
        raf = 0;
    };
    layout();
    new ResizeObserver(()=>layout()).observe(stage);
    if ((0, $5c38d4c8775354e7$export$c7559910573e9368)()) {
        counts.vendor = 420;
        counts.employer = 420;
        counts.harness = 0;
        [
            "vendor",
            "employer",
            "harness"
        ].forEach(setCount);
        return;
    }
    let autoTimer = 0;
    (0, $5c38d4c8775354e7$export$36a0c1ca2ae264fa)(stage, (on)=>{
        visible = on;
        if (on) {
            start();
            if (!touched && !local && !autoTimer) autoTimer = window.setTimeout(()=>{
                if (!touched && visible) setLocal(true);
            }, 4500);
        } else {
            stop();
            clearTimeout(autoTimer);
            autoTimer = 0;
        }
    }, 0.3);
    document.addEventListener("visibilitychange", ()=>document.hidden ? stop() : visible && start());
}



// Fig. 11 (clusters): 1,000 interventions collapsing into 15 gravity wells on scroll,
// leaving 10% glowing green stars free.
const $d64e07c83f960d39$var$CLUSTER_COUNT = 15;
const $d64e07c83f960d39$var$N = 1000;
const $d64e07c83f960d39$var$RARE = 0.1;
function $d64e07c83f960d39$var$gauss(r) {
    return Math.sqrt(-2 * Math.log(r() + 1e-9)) * Math.cos(2 * Math.PI * r());
}
function $d64e07c83f960d39$export$41850b5b35db191(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxk");
    const canvas = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("canvas", "fxk-canvas");
    canvas.setAttribute("aria-hidden", "true");
    const hud = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxk-hud");
    const hudMain = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxk-hud__main");
    hud.append(hudMain);
    stage.append(canvas, hud);
    fig.prepend(stage);
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    let W = 0;
    let H = 0;
    let narrow = false;
    let pts = [];
    let centers = [];
    let colors = {
        tx: "",
        tx2: "",
        tx3: "",
        green: "",
        bg: ""
    };
    let shown = 0;
    let raf = 0;
    let visible = false;
    const build = ()=>{
        const dpr = Math.min(2, window.devicePixelRatio || 1);
        W = stage.clientWidth || 680;
        narrow = W < 560;
        H = narrow ? 250 : 280;
        canvas.width = Math.round(W * dpr);
        canvas.height = Math.round(H * dpr);
        canvas.style.width = `${W}px`;
        canvas.style.height = `${H}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        const r = (0, $5c38d4c8775354e7$export$5c03d20f483e909a)(20261025);
        const cols = narrow ? 3 : 5;
        const rows = Math.ceil($d64e07c83f960d39$var$CLUSTER_COUNT / cols);
        const top = 42;
        const cw = (W - 24) / cols;
        const ch = (H - top - 16) / rows;
        const weights = Array.from({
            length: $d64e07c83f960d39$var$CLUSTER_COUNT
        }, (_, i)=>1 / Math.pow(i + 1, 0.75));
        const wsum = weights.reduce((a, b)=>a + b, 0);
        const clustered = Math.round($d64e07c83f960d39$var$N * (1 - $d64e07c83f960d39$var$RARE));
        const cells = Array.from({
            length: cols * rows
        }, (_, i)=>i).map((i)=>({
                i: i,
                d: Math.hypot(i % cols - (cols - 1) / 2, Math.floor(i / cols) - (rows - 1) / 2) + r() * 0.3
            })).sort((a, b)=>a.d - b.d);
        centers = weights.map((w, k)=>{
            const cell = cells[k].i;
            return {
                x: 12 + cw * (cell % cols + 0.5) + (r() - 0.5) * cw * 0.12,
                y: top + ch * (Math.floor(cell / cols) + 0.5) + (r() - 0.5) * ch * 0.1,
                n: Math.round(w / wsum * clustered),
                r: 0
            };
        });
        pts = [];
        const pad = 12;
        const spread = Math.min(cw, ch) * 0.15;
        centers.forEach((c, k)=>{
            const rad = spread * (0.5 + Math.sqrt(c.n) / 12);
            c.r = rad;
            for(let i = 0; i < c.n; i++)pts.push({
                sx: pad + r() * (W - pad * 2),
                sy: top - 10 + r() * (H - top),
                tx: c.x + $d64e07c83f960d39$var$gauss(r) * rad,
                ty: c.y + $d64e07c83f960d39$var$gauss(r) * rad * 0.8,
                c: k,
                delay: r() * 0.35
            });
        });
        while(pts.length < $d64e07c83f960d39$var$N){
            const x = pad + r() * (W - pad * 2);
            const y = top - 10 + r() * (H - top);
            pts.push({
                sx: x,
                sy: y,
                tx: x,
                ty: y,
                c: -1,
                delay: r() * 0.35
            });
        }
        colors = {
            tx: (0, $5c38d4c8775354e7$export$8b4981022bd80a4e)("tx"),
            tx2: (0, $5c38d4c8775354e7$export$8b4981022bd80a4e)("tx2"),
            tx3: (0, $5c38d4c8775354e7$export$8b4981022bd80a4e)("tx3"),
            green: (0, $5c38d4c8775354e7$export$8b4981022bd80a4e)("green"),
            bg: (0, $5c38d4c8775354e7$export$8b4981022bd80a4e)("bg2")
        };
    };
    const ease = (k)=>k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
    let hudKey = "";
    const setHud = (main)=>{
        if (main === hudKey) return;
        hudKey = main;
        hudMain.innerHTML = main;
    };
    const draw = ()=>{
        ctx.clearRect(0, 0, W, H);
        const p = shown;
        const size = narrow ? 2 : 2.4;
        // Subtle gravity rings around the 15 wells as they lock in
        const la = Math.min(1, Math.max(0, (p - 0.65) / 0.25));
        if (la > 0) {
            ctx.strokeStyle = colors.tx3;
            ctx.globalAlpha = la * 0.35;
            ctx.lineWidth = 1;
            centers.forEach((c)=>{
                ctx.beginPath();
                ctx.arc(c.x, c.y, c.r * 2.1, 0, Math.PI * 2);
                ctx.stroke();
            });
        }
        for (const q of pts){
            const k = ease(Math.min(1, Math.max(0, (p - q.delay) / 0.6)));
            const x = q.sx + (q.tx - q.sx) * k;
            const y = q.sy + (q.ty - q.sy) * k;
            if (q.c < 0) {
                const g = Math.min(1, Math.max(0, (p - 0.65) / 0.25));
                ctx.globalAlpha = 0.55 + 0.45 * g;
                ctx.fillStyle = g > 0.4 ? colors.green : colors.tx2;
                const sz = size + g * 1.6;
                ctx.fillRect(x - sz / 2, y - sz / 2, sz, sz);
            } else {
                ctx.globalAlpha = 0.45 + 0.3 * k;
                ctx.fillStyle = k > 0.95 ? colors.tx : colors.tx2;
                ctx.fillRect(x - size / 2, y - size / 2, size, size);
            }
        }
        ctx.globalAlpha = 1;
        setHud('90% \xb7 15 rules &nbsp;&nbsp;<span class="fxk-green">\u25A0 10% \xb7 rare</span>');
    };
    let drawn = -1;
    const tick = ()=>{
        raf = requestAnimationFrame(tick);
        const target = (0, $5c38d4c8775354e7$export$d16895a5a96f4)(stage, 0.95, 0.15);
        shown += (target - shown) * 0.12;
        if (Math.abs(target - shown) < 0.001) shown = target;
        if (shown === drawn) return;
        drawn = shown;
        draw();
    };
    build();
    new ResizeObserver(()=>{
        if (Math.abs(stage.clientWidth - W) > 1) {
            build();
            draw();
        }
    }).observe(stage);
    if ((0, $5c38d4c8775354e7$export$c7559910573e9368)()) {
        shown = 1;
        draw();
        return;
    }
    shown = (0, $5c38d4c8775354e7$export$d16895a5a96f4)(stage, 0.95, 0.15);
    draw();
    (0, $5c38d4c8775354e7$export$36a0c1ca2ae264fa)(stage, (on)=>{
        visible = on;
        if (on && !raf) raf = requestAnimationFrame(tick);
        if (!on) {
            cancelAnimationFrame(raf);
            raf = 0;
        }
    }, 0);
}



// Fig. 18 (ladder): The entropy ladder. Scroll compiles lower rungs into green
// checks and pushes the red boundary of "you" upward.
const $9dce61d788f521b3$var$RUNG_COUNT = 8;
const $9dce61d788f521b3$var$CHECK_COUNT = 5;
function $9dce61d788f521b3$export$27c9715a72c1f992(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxl");
    const head = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxl-head");
    const legend = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("span", "fxl-legend");
    legend.append((0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("i", "fxl-legend__line"), "you");
    head.append((0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("span", "fxl-head__label", "entropy \u2191"), legend);
    const ladder = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("ol", "fxl-ladder");
    const rows = [];
    for(let i = 0; i < $9dce61d788f521b3$var$RUNG_COUNT; i++){
        const canCheck = i < $9dce61d788f521b3$var$CHECK_COUNT;
        const li = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("li", `fxl-rung${canCheck ? "" : " is-open"}`);
        li.style.setProperty("--i", String(i));
        const bar = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("span", "fxl-rung__bar");
        const badge = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("span", "fxl-rung__badge", canCheck ? "\xb7" : "?");
        li.append(bar, badge);
        rows.push(li);
    }
    [
        ...rows
    ].reverse().forEach((li)=>ladder.append(li));
    const boundary = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxl-boundary");
    const climber = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxl-you", "\u25B6");
    ladder.append(boundary, climber);
    stage.append(head, ladder);
    fig.prepend(stage);
    let current = -1;
    const apply = (w)=>{
        if (w === current) return;
        current = w;
        rows.forEach((li, i)=>{
            const done = i < w;
            li.classList.toggle("is-check", done);
            if (i < $9dce61d788f521b3$var$CHECK_COUNT) li.querySelector(".fxl-rung__badge").textContent = done ? "\u2713" : "\xb7";
        });
        const rung = rows[Math.min(w, rows.length - 1)];
        const top = rung.offsetTop + rung.offsetHeight;
        boundary.style.transform = `translateY(${top}px)`;
        climber.style.transform = `translate(${rung.offsetLeft - 16}px, ${rung.offsetTop + rung.offsetHeight / 2}px)`;
    };
    const update = ()=>apply(Math.round((0, $5c38d4c8775354e7$export$d16895a5a96f4)(stage, 0.85, 0.25) * $9dce61d788f521b3$var$CHECK_COUNT));
    const relayout = ()=>{
        const w = current < 0 ? 0 : current;
        current = -1;
        apply(w);
    };
    new ResizeObserver(relayout).observe(stage);
    if ((0, $5c38d4c8775354e7$export$c7559910573e9368)()) {
        apply($9dce61d788f521b3$var$CHECK_COUNT);
        return;
    }
    apply(0);
    let raf = 0;
    const onScroll = ()=>{
        if (raf) return;
        raf = requestAnimationFrame(()=>{
            raf = 0;
            update();
        });
    };
    (0, $5c38d4c8775354e7$export$36a0c1ca2ae264fa)(stage, (on)=>{
        if (on) {
            window.addEventListener("scroll", onScroll, {
                passive: true
            });
            update();
        } else window.removeEventListener("scroll", onScroll);
    }, 0);
}



function $8646d2e2bbbd7e5f$export$1dc8de7c9cf5d13(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const r = (0, $5c38d4c8775354e7$export$5c03d20f483e909a)(101);
    const ions = Array.from({
        length: 130
    }, ()=>({
            x: r(),
            y0: 0.46 + (r() - 0.5) * 0.08,
            speed: 0.22 + r() * 0.16,
            veto: r() < 0.12,
            phase: r() * Math.PI * 2,
            trail: []
        }));
    const boostSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0);
    stage.style.cursor = "pointer";
    stage.addEventListener("click", ()=>{
        boostSp.vel += 4.5;
    });
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 215 : 245, (ctx, W, H, c, t, dt, pointer)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        boostSp.target = pointer.inside ? 0.45 : 0;
        const boost = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(boostSp.step(dt, 140, 16), 0, 1.5);
        const splitX = W * 0.42;
        const crystalX = W * 0.82;
        const crystalY = H * 0.28;
        const troughY = H * 0.81;
        const beamY = H * 0.46;
        // Magnetic field flux rings around the separator plane
        ctx.save();
        for(let k = 0; k < 3; k++){
            const rad = 18 + k * 14 + Math.sin(t * 2.5 + k) * 3;
            ctx.strokeStyle = c.tx3;
            ctx.globalAlpha = 0.14 - k * 0.03;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.ellipse(splitX, beamY, rad * 0.45, rad * 1.6, 0, 0, Math.PI * 2);
            ctx.stroke();
        }
        ctx.restore();
        // Separator vertical axis
        ctx.strokeStyle = c.tx3;
        ctx.globalAlpha = 0.45;
        ctx.setLineDash([
            2,
            4
        ]);
        ctx.beginPath();
        ctx.moveTo(splitX, 18);
        ctx.lineTo(splitX, H - 18);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.globalAlpha = 1;
        // Update & draw ion streams with velocity ribbon trails
        for (const p of ions){
            const prevX = p.x;
            p.x += p.speed * dt * (1 + boost * 0.45);
            if (p.x > 0.9) {
                p.x = 0.04;
                p.y0 = 0.46 + (r() - 0.5) * 0.07;
                p.veto = r() < 0.12 + boost * 0.18;
                p.trail.length = 0;
            }
            const px = p.x * W;
            let py = p.y0 * H;
            if (p.x > 0.4) {
                const u = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)((p.x - 0.4) / 0.42);
                const e = (0, $5c38d4c8775354e7$export$24656b269d8df7d6)(u);
                const destY = p.veto ? crystalY + Math.sin(t * 3.2 + p.phase) * 7 : troughY + Math.cos(p.phase * 5) * 6;
                py = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(py, destY, e);
            }
            if (p.x > prevX) {
                p.trail.push([
                    px,
                    py
                ]);
                if (p.trail.length > (p.veto ? 8 : 4)) p.trail.shift();
            }
            if (p.veto && p.x > 0.36) {
                const col = p.x > 0.52 ? c.green : c.red;
                if (p.trail.length > 1) {
                    ctx.strokeStyle = col;
                    ctx.globalAlpha = 0.45;
                    ctx.lineWidth = 1.8;
                    ctx.beginPath();
                    ctx.moveTo(p.trail[0][0], p.trail[0][1]);
                    for(let i = 1; i < p.trail.length; i++)ctx.lineTo(p.trail[i][0], p.trail[i][1]);
                    ctx.stroke();
                }
                (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, py, 2.6, col, 0.22, 2.8);
            } else {
                ctx.fillStyle = c.tx3;
                ctx.globalAlpha = p.x > 0.42 ? 0.28 : 0.52;
                ctx.fillRect(px - 1.5, py - 1.5, 3, 3);
            }
        }
        ctx.globalAlpha = 1;
        // 3D Isometric rotating weight octahedron / crystal at (crystalX, crystalY)
        const rad = 24 + boost * 6;
        const rot = t * 0.65;
        const verts = [
            [
                0,
                -rad
            ],
            [
                Math.cos(rot) * rad,
                0
            ],
            [
                Math.sin(rot) * rad * 0.7,
                rad * 0.35
            ],
            [
                -Math.cos(rot) * rad,
                0
            ],
            [
                -Math.sin(rot) * rad * 0.7,
                -rad * 0.35
            ],
            [
                0,
                rad
            ]
        ];
        ctx.save();
        ctx.translate(crystalX, crystalY);
        ctx.strokeStyle = c.green;
        ctx.fillStyle = c.green;
        ctx.globalAlpha = 0.1;
        ctx.beginPath();
        ctx.arc(0, 0, rad * 1.25, 0, Math.PI * 2);
        ctx.fill();
        ctx.globalAlpha = 0.85;
        ctx.lineWidth = 1.4;
        const edges = [
            [
                0,
                1
            ],
            [
                0,
                2
            ],
            [
                0,
                3
            ],
            [
                0,
                4
            ],
            [
                5,
                1
            ],
            [
                5,
                2
            ],
            [
                5,
                3
            ],
            [
                5,
                4
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                1
            ]
        ];
        ctx.beginPath();
        for (const [i, j] of edges){
            ctx.moveTo(verts[i][0], verts[i][1]);
            ctx.lineTo(verts[j][0], verts[j][1]);
        }
        ctx.stroke();
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, 0, 0, 3.5, c.green, 0.35, 3.2);
        ctx.restore();
        // Collector trough bar at bottom right
        ctx.strokeStyle = c.tx3;
        ctx.globalAlpha = 0.5;
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.moveTo(crystalX - 42, troughY + 8);
        ctx.lineTo(crystalX - 42, troughY + 14);
        ctx.lineTo(crystalX + 42, troughY + 14);
        ctx.lineTo(crystalX + 42, troughY + 8);
        ctx.stroke();
        ctx.globalAlpha = 1;
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "tokens", 22, beamY - 22, c.tx2, c.bg, c.ui, "left");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "weights", crystalX, crystalY + rad + 18, c.green, c.bg, c.green, "center");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "$1 noise", crystalX, troughY - 14, c.tx2, c.bg, c.ui, "center");
    });
}
function $8646d2e2bbbd7e5f$export$c10e76ebe093ee46(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    const toggle = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxv-pill");
    const bOld = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn", "1985");
    const bNew = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn is-active", "2026");
    bOld.type = "button";
    bNew.type = "button";
    toggle.append(bOld, bNew);
    stage.append(toggle);
    fig.prepend(stage);
    const eraSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(1); // 0 = 1985, 1 = 2026
    const ctrl = (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 210 : 235, (ctx, W, H, c, t, dt)=>{
        const anim = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(eraSp.step(dt, 150, 20), 0, 1);
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        const deskX = W * 0.14;
        const doorX = W * 0.54;
        const vaultX = W * 0.34;
        const vaultY = H * 0.8;
        const outX = W * 0.86;
        const midY = H * 0.42;
        // Exit threshold gate with architectural ticks
        ctx.strokeStyle = c.tx2;
        ctx.globalAlpha = 0.55;
        ctx.lineWidth = 1.4;
        ctx.setLineDash([
            3,
            4
        ]);
        ctx.beginPath();
        ctx.moveTo(doorX, 26);
        ctx.lineTo(doorX, H - 20);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.globalAlpha = 1;
        // Code stream (always loops back into employer vault)
        ctx.strokeStyle = c.tx3;
        ctx.globalAlpha = 0.65;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(deskX, midY - 8);
        ctx.bezierCurveTo(doorX - 42, midY - 8, doorX - 42, vaultY, vaultX, vaultY);
        ctx.stroke();
        ctx.globalAlpha = 1;
        // Judgment stream: smoothly bends from exiting door (1985) into company vault (2026)
        const endX = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(outX, vaultX, anim);
        const endY = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(midY + 6, vaultY, anim);
        const cp1X = doorX - 6;
        const cp1Y = midY + 6;
        const cp2X = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(doorX + 64, doorX - 18, anim);
        const cp2Y = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(midY + 6, vaultY - 8, anim);
        const streamCol = anim > 0.5 ? c.red : c.green;
        // Soft glow behind judgment curve
        ctx.strokeStyle = streamCol;
        ctx.globalAlpha = 0.18;
        ctx.lineWidth = 7;
        ctx.beginPath();
        ctx.moveTo(deskX, midY + 6);
        ctx.bezierCurveTo(cp1X, cp1Y, cp2X, cp2Y, endX, endY);
        ctx.stroke();
        ctx.globalAlpha = 0.95;
        ctx.lineWidth = 2.4;
        ctx.beginPath();
        ctx.moveTo(deskX, midY + 6);
        ctx.bezierCurveTo(cp1X, cp1Y, cp2X, cp2Y, endX, endY);
        ctx.stroke();
        ctx.globalAlpha = 1;
        // Animated luminous packets along the judgment curve
        for(let i = 0; i < 8; i++){
            const u = (t * 0.34 + i / 8) % 1;
            const inv = 1 - u;
            const x = inv * inv * inv * deskX + 3 * inv * inv * u * cp1X + 3 * inv * u * u * cp2X + u * u * u * endX;
            const y = inv * inv * inv * (midY + 6) + 3 * inv * inv * u * cp1Y + 3 * inv * u * u * cp2Y + u * u * u * endY;
            (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, x, y, 2.8, streamCol, 0.25, 2.6);
        }
        // Origin engineer workstation node
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, deskX, midY, 5.5, c.tx, 0.15, 2.5);
        // Company vault node
        ctx.fillStyle = c.bg;
        ctx.strokeStyle = anim > 0.5 ? c.red : c.tx2;
        ctx.lineWidth = 1.8;
        ctx.beginPath();
        ctx.roundRect(vaultX - 34, vaultY - 13, 68, 26, 4);
        ctx.fill();
        ctx.stroke();
        // Departing engineer halo outside the door
        ctx.save();
        ctx.translate(outX, midY + 6);
        ctx.strokeStyle = anim < 0.5 ? c.green : c.tx3;
        ctx.lineWidth = 1.8;
        if (anim > 0.5) ctx.setLineDash([
            3,
            3
        ]);
        ctx.beginPath();
        ctx.arc(0, 0, 15, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
        if (anim < 0.5) (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, outX, midY + 6, 4.5, c.green, 0.3 * (1 - anim), 3);
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "exit", doorX, 18, c.tx2, c.bg, c.ui, "center");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "code", vaultX, vaultY, anim > 0.5 ? c.red : c.tx2, c.bg, anim > 0.5 ? c.red : c.ui, "center");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "judgment", (deskX + doorX) * 0.48, midY - 20, streamCol, c.bg, streamCol, "center");
    });
    const setEra = (target)=>{
        eraSp.target = target;
        bOld.classList.toggle("is-active", target === 0);
        bNew.classList.toggle("is-active", target === 1);
        ctrl.redraw();
    };
    bOld.addEventListener("click", ()=>setEra(0));
    bNew.addEventListener("click", ()=>setEra(1));
    stage.style.cursor = "pointer";
    stage.addEventListener("click", (e)=>{
        if (e.target.closest("button")) return;
        setEra(eraSp.target > 0.5 ? 0 : 1);
    });
}



function $97dcc32b9b6ba392$export$ee5e7d054da6f733(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const r = (0, $5c38d4c8775354e7$export$5c03d20f483e909a)(404);
    const PATTERNS = Array.from({
        length: 6
    }, (_, row)=>Array.from({
            length: 18
        }, ()=>{
            if (row === 0) return 0;
            const v = r();
            if (v < 0.18 + row * 0.06) return -1;
            if (v < 0.36 + row * 0.09) return 1;
            return 0;
        }));
    let hoverRow = 4;
    const rowSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(4);
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 210 : 235, (ctx, W, H, c, t, dt, pointer)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        if (pointer.inside) hoverRow = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(Math.round((pointer.y - 0.12) / 0.15), 0, 5);
        rowSp.target = hoverRow;
        const focus = rowSp.step(dt, 180, 22);
        const px = W * 0.33;
        const py = H * 0.5;
        // Incoming single prompt laser beam + underglow
        ctx.strokeStyle = c.tx;
        ctx.globalAlpha = 0.14;
        ctx.lineWidth = 6;
        ctx.beginPath();
        ctx.moveTo(24, py);
        ctx.lineTo(px - 18, py);
        ctx.stroke();
        ctx.globalAlpha = 0.9;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(24, py);
        ctx.lineTo(px - 18, py);
        ctx.stroke();
        ctx.globalAlpha = 1;
        // Traveling photon pulse on input beam
        const pulseX = 24 + t * 110 % Math.max(12, px - 42);
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, pulseX, py, 3, c.tx, 0.25, 2.8);
        // 6 refracted beams + diff barcode strips
        const startX = W * 0.54;
        const stripW = W * 0.38;
        const blockW = Math.max(3, (stripW - 36) / 18);
        for(let i = 0; i < 6; i++){
            const ry = 30 + i / 5 * (H - 60);
            const prox = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(1 - Math.abs(focus - i));
            ctx.strokeStyle = prox > 0.5 ? i === 0 ? c.red : c.green : c.tx3;
            ctx.globalAlpha = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(0.28, 0.92, prox);
            ctx.lineWidth = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(1, 2.2, prox);
            ctx.beginPath();
            ctx.moveTo(px + 14, py - 4 + (i - 2.5) * 3);
            ctx.bezierCurveTo(px + 62, py, startX - 48, ry, startX - 4, ry);
            ctx.stroke();
            // Barcode blocks along the lane
            const pat = PATTERNS[i];
            for(let j = 0; j < pat.length; j++){
                const kind = pat[j];
                const bx = startX + j * (blockW + 2);
                const bh = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(7, 13, prox);
                ctx.fillStyle = kind < 0 ? c.red : kind > 0 ? c.green : c.tx3;
                ctx.globalAlpha = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(kind === 0 ? 0.16 : 0.48, kind === 0 ? 0.38 : 0.96, prox);
                ctx.fillRect(bx, ry - bh * 0.5, blockW, bh);
            }
        }
        ctx.globalAlpha = 1;
        // Central optical prism with internal facets
        ctx.save();
        ctx.translate(px, py);
        ctx.fillStyle = c.bg;
        ctx.strokeStyle = c.tx;
        ctx.lineWidth = 1.8;
        ctx.beginPath();
        ctx.moveTo(0, -26);
        ctx.lineTo(24, 18);
        ctx.lineTo(-24, 18);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.strokeStyle = c.green;
        ctx.globalAlpha = 0.35;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(-12, 2);
        ctx.lineTo(14, -2);
        ctx.lineTo(8, 12);
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "1 prompt", 24, py - 20, c.tx2, c.bg, c.ui, "left");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "agent", px, py + 34, c.tx2, c.bg, c.ui, "center");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "6 diffs", W - 18, 18, c.green, c.bg, c.green, "right");
    });
    stage.style.cursor = "ns-resize";
}
function $97dcc32b9b6ba392$export$eed79ea19baf81a9(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    const pill = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxv-pill");
    const btn = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn", "compile");
    btn.type = "button";
    pill.append(btn);
    stage.append(pill);
    fig.prepend(stage);
    let compiled = false;
    const compSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0);
    const toggle = ()=>{
        compiled = !compiled;
        compSp.target = compiled ? 1 : 0;
        btn.classList.toggle("is-active", compiled);
    };
    stage.style.cursor = "pointer";
    stage.addEventListener("click", toggle);
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 205 : 230, (ctx, W, H, c, t, dt)=>{
        const k = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(compSp.step(dt, 150, 18), 0, 1);
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        const cx = W * 0.34;
        const cy = H * 0.55;
        const rad = Math.min(64, H * 0.33);
        // Circular retry orbit
        ctx.strokeStyle = k > 0.5 ? c.tx3 : c.red;
        ctx.globalAlpha = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(0.65, 0.22, k);
        ctx.lineWidth = 1.8;
        ctx.setLineDash([
            4,
            4
        ]);
        ctx.beginPath();
        ctx.arc(cx, cy, rad, 0, Math.PI * 2);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.globalAlpha = 1;
        const wallX = cx;
        const wallY = cy - rad;
        // Tangent escape beam when compiled
        const exitEnd = W * 0.88;
        if (k > 0.01) {
            const curEnd = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(wallX, exitEnd, k);
            ctx.strokeStyle = c.green;
            ctx.globalAlpha = 0.18 * k;
            ctx.lineWidth = 7;
            ctx.beginPath();
            ctx.moveTo(wallX, wallY);
            ctx.lineTo(curEnd, wallY);
            ctx.stroke();
            ctx.globalAlpha = k;
            ctx.lineWidth = 2.4;
            ctx.beginPath();
            ctx.moveTo(wallX, wallY);
            ctx.lineTo(curEnd, wallY);
            ctx.stroke();
            ctx.globalAlpha = 1;
        }
        // Gate / wall at 12 o'clock
        ctx.save();
        ctx.translate(wallX, wallY);
        ctx.rotate((0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(0.65, 0, k));
        ctx.strokeStyle = k > 0.5 ? c.green : c.red;
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.moveTo(-9, 0);
        ctx.lineTo(9, 0);
        ctx.stroke();
        ctx.restore();
        // Orbiting / escaping particles
        for(let i = 0; i < 6; i++){
            const u = (t * 0.52 + i / 6) % 1;
            if (k < 0.5) {
                const ang = -Math.PI / 2 + u * Math.PI * 2;
                const px = cx + Math.cos(ang) * rad;
                const py = cy + Math.sin(ang) * rad;
                const hit = u < 0.09;
                (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, py, hit ? 4.2 : 2.8, hit ? c.red : c.tx2, hit ? 0.35 : 0.1, 3);
            } else if (u < 0.35) {
                const ang = Math.PI / 2 + u / 0.35 * Math.PI;
                const px = cx + Math.cos(ang) * rad;
                const py = cy + Math.sin(ang) * rad;
                (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, py, 2.8, c.tx2, 0.1, 2);
            } else {
                const lin = (u - 0.35) / 0.65;
                const px = wallX + lin * (exitEnd - wallX) * k;
                (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, wallY, 3.4, c.green, 0.28, 2.8);
            }
        }
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "loop", cx, cy, k > 0.5 ? c.tx3 : c.red, c.bg, k > 0.5 ? c.ui : c.red, "center");
        if (k > 0.25) (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "rule", (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(wallX + 40, exitEnd, k), wallY - 18, c.green, c.bg, c.green, "right");
    });
}



function $ed5b5a7f3206661a$export$51dce08b3efe5596(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const r = (0, $5c38d4c8775354e7$export$5c03d20f483e909a)(606);
    const rows = Array.from({
        length: 11
    }, (_, i)=>({
            indent: i % 3 * 14,
            bars: Array.from({
                length: 3 + i % 4
            }, ()=>18 + r() * 58)
        }));
    const lxSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0.52);
    const lySp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0.5);
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 210 : 240, (ctx, W, H, c, t, dt, pointer)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        if (pointer.inside) {
            lxSp.target = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(pointer.x, 0.16, 0.84);
            lySp.target = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(pointer.y, 0.22, 0.78);
        } else {
            lxSp.target = 0.52 + Math.cos(t * 0.65) * 0.22;
            lySp.target = 0.5 + Math.sin(t * 0.95) * 0.16;
        }
        const cx = lxSp.step(dt, 180, 22) * W;
        const cy = lySp.step(dt, 180, 22) * H;
        const rad = Math.min(82, W * 0.21);
        const padX = W * 0.14;
        // 1. Exterior calm git diff bars
        rows.forEach((row, i)=>{
            const y = 30 + i * 16;
            let x = padX + row.indent;
            ctx.fillStyle = c.tx3;
            ctx.globalAlpha = 0.34;
            for (const bw of row.bars){
                ctx.fillRect(x, y, bw, 5);
                x += bw + 6;
            }
        });
        ctx.globalAlpha = 1;
        // 2. Clipped interior X-ray lens: hidden telemetry wires & red/green veto nodes
        ctx.save();
        ctx.beginPath();
        ctx.arc(cx, cy, rad, 0, Math.PI * 2);
        ctx.clip();
        ctx.fillStyle = c.bg;
        ctx.fillRect(cx - rad, cy - rad, rad * 2, rad * 2);
        // Fine cross-grid inside optical loupe
        ctx.strokeStyle = c.ui;
        ctx.lineWidth = 1;
        for(let x = cx - rad; x <= cx + rad; x += 14){
            ctx.beginPath();
            ctx.moveTo(x, cy - rad);
            ctx.lineTo(x, cy + rad);
            ctx.stroke();
        }
        for(let y = cy - rad; y <= cy + rad; y += 14){
            ctx.beginPath();
            ctx.moveTo(cx - rad, y);
            ctx.lineTo(cx + rad, y);
            ctx.stroke();
        }
        // Telemetry extraction splines converging to collector
        ctx.strokeStyle = c.red;
        ctx.globalAlpha = 0.32;
        ctx.lineWidth = 1.2;
        for(let i = 0; i < rows.length; i++){
            const y = 30 + i * 16 + 2.5;
            ctx.beginPath();
            ctx.moveTo(padX, y);
            ctx.bezierCurveTo(cx, y - 10, cx, cy, W - padX, 26);
            ctx.stroke();
        }
        rows.forEach((row, i)=>{
            const y = 30 + i * 16;
            let x = padX + row.indent;
            for(let j = 0; j < row.bars.length; j++){
                const bw = row.bars[j];
                const isVeto = (i + j) % 2 === 0;
                ctx.fillStyle = isVeto ? c.red : c.green;
                ctx.globalAlpha = 0.88;
                ctx.fillRect(x, y - 1, bw, 7);
                x += bw + 6;
            }
        });
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "telemetry", cx, cy - rad + 20, c.red, c.bg, c.red, "center");
        ctx.restore();
        // Optical loupe double bezel + degree ticks
        ctx.save();
        ctx.translate(cx, cy);
        ctx.strokeStyle = c.tx;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(0, 0, rad, 0, Math.PI * 2);
        ctx.stroke();
        ctx.strokeStyle = c.tx3;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(0, 0, rad + 4, 0, Math.PI * 2);
        ctx.stroke();
        for(let a = 0; a < 12; a++){
            const ang = a / 12 * Math.PI * 2 + t * 0.15;
            ctx.beginPath();
            ctx.moveTo(Math.cos(ang) * (rad - 4), Math.sin(ang) * (rad - 4));
            ctx.lineTo(Math.cos(ang) * rad, Math.sin(ang) * rad);
            ctx.stroke();
        }
        ctx.restore();
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "git push", 18, 20, c.tx2, c.bg, c.ui, "left");
    });
    stage.style.cursor = "grab";
}
function $ed5b5a7f3206661a$export$d39a347e090d9af1(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const progSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0.65);
    let userScrubbed = false;
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 210 : 240, (ctx, W, H, c, t, dt, pointer)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        if (pointer.inside) {
            userScrubbed = true;
            progSp.target = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(pointer.x, 0.05, 1);
        } else if (!userScrubbed) progSp.target = 0.18 + 0.76 * (0.5 + 0.5 * Math.sin(t * 0.45));
        const p = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(progSp.step(dt, 140, 20), 0.02, 1);
        const cols = 8;
        const rows = 8;
        const total = cols * rows;
        const keep = Math.max(5, Math.round(total * Math.pow(1 - p * 0.88, 1.3)));
        const gx0 = W * 0.08;
        const gy0 = 38;
        const cell = Math.min(18, W * 0.34 / cols);
        for(let i = 0; i < total; i++){
            const col = i % cols;
            const row = Math.floor(i / cols);
            const x = gx0 + col * cell;
            const y = gy0 + row * cell;
            const active = i < keep;
            if (active) {
                ctx.fillStyle = c.tx;
                ctx.fillRect(x, y, cell - 4, cell - 4);
            } else {
                ctx.strokeStyle = c.red;
                ctx.globalAlpha = 0.36;
                ctx.lineWidth = 1;
                ctx.strokeRect(x + 0.5, y + 0.5, cell - 5, cell - 5);
                ctx.globalAlpha = 1;
            }
        }
        // Right: Multi-ridgeline elevation contour of company weights
        const rx0 = W * 0.5;
        const rx1 = W * 0.94;
        const baseH = H - 30;
        const maxPeak = (H - 72) * p;
        for(let layer = 4; layer >= 0; layer--){
            const lk = (layer + 1) / 5;
            const peakH = baseH - maxPeak * lk;
            ctx.beginPath();
            ctx.moveTo(rx0, baseH);
            for(let k = 0; k <= 36; k++){
                const u = k / 36;
                const x = rx0 + u * (rx1 - rx0);
                const env = Math.sin(u * Math.PI);
                const ridge = 1 - 0.14 * Math.cos(u * Math.PI * 4 + layer * 0.8);
                const y = baseH - env * ridge * (baseH - peakH);
                ctx.lineTo(x, y);
            }
            ctx.lineTo(rx1, baseH);
            ctx.closePath();
            ctx.fillStyle = c.green;
            ctx.globalAlpha = 0.06;
            ctx.fill();
            ctx.strokeStyle = c.green;
            ctx.globalAlpha = layer === 4 ? 0.95 : 0.28;
            ctx.lineWidth = layer === 4 ? 2.2 : 1;
            ctx.stroke();
        }
        ctx.globalAlpha = 1;
        // Flowing particle arcs from drained seats into the peak
        const topPeakY = baseH - maxPeak;
        const midPeakX = (rx0 + rx1) * 0.5;
        for(let k = 0; k < 5; k++){
            const sy = gy0 + k * 15 % (rows * cell);
            const sx = gx0 + cols * cell;
            ctx.strokeStyle = c.red;
            ctx.globalAlpha = 0.2;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(sx, sy);
            ctx.bezierCurveTo(W * 0.45, sy - 18, W * 0.48, topPeakY + 8, midPeakX, topPeakY + 12);
            ctx.stroke();
            const u = (t * 0.4 + k * 0.2) % 1;
            const inv = 1 - u;
            const px = inv * inv * inv * sx + 3 * inv * inv * u * (W * 0.45) + 3 * inv * u * u * (W * 0.48) + u * u * u * midPeakX;
            const py = inv * inv * inv * sy + 3 * inv * inv * u * (sy - 18) + 3 * inv * u * u * (topPeakY + 8) + u * u * u * (topPeakY + 12);
            (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, py, 2.2, u > 0.55 ? c.green : c.red, 0.2, 2.4);
        }
        ctx.globalAlpha = 1;
        // Scrubber track along bottom
        ctx.fillStyle = c.ui;
        ctx.fillRect(gx0, H - 14, rx1 - gx0, 2);
        ctx.fillStyle = c.tx;
        ctx.fillRect(gx0, H - 15, (rx1 - gx0) * p, 4);
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "staff", gx0, 20, c.tx2, c.bg, c.ui, "left");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "weights", rx1, 20, c.green, c.bg, c.green, "right");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, `${Math.round(p * 24)}m`, gx0 + (rx1 - gx0) * p, H - 24, c.tx, c.bg, c.ui, "center");
    });
    stage.style.cursor = "ew-resize";
}
function $ed5b5a7f3206661a$export$a997277d1a38e7f8(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    let fast = false;
    const rateSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(2.3);
    stage.style.cursor = "pointer";
    stage.addEventListener("click", ()=>{
        fast = !fast;
        rateSp.target = fast ? 3.4 : 2.3;
    });
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 205 : 235, (ctx, W, H, c, t, dt)=>{
        const rate = rateSp.step(dt, 140, 18);
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        const x0 = 28;
        const x1 = W - 28;
        const flatY = H * 0.78;
        const topY = H * 0.16;
        // Stateless flatline at bottom
        ctx.strokeStyle = c.red;
        ctx.globalAlpha = 0.7;
        ctx.lineWidth = 1.6;
        ctx.setLineDash([
            4,
            4
        ]);
        ctx.beginPath();
        ctx.moveTo(x0, flatY);
        ctx.lineTo(x1, flatY);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.globalAlpha = 1;
        const steps = 14;
        const stepW = (x1 - x0) / steps;
        ctx.beginPath();
        ctx.moveTo(x0, flatY);
        for(let i = 0; i < steps; i++){
            const u = (i + 1) / steps;
            const k = 1 - Math.exp(-u * rate);
            const y = flatY - k * (flatY - topY);
            const sx = x0 + i * stepW;
            const nx = x0 + (i + 1) * stepW;
            ctx.lineTo(sx, y);
            ctx.lineTo(nx, y);
        }
        ctx.strokeStyle = c.green;
        ctx.lineWidth = 2.4;
        ctx.stroke();
        // Shaded compounding capital wedge with vertical riser ticks
        ctx.lineTo(x1, flatY);
        ctx.lineTo(x0, flatY);
        ctx.closePath();
        ctx.fillStyle = c.green;
        ctx.globalAlpha = 0.1;
        ctx.fill();
        ctx.globalAlpha = 1;
        for(let i = 0; i < steps; i++){
            const u = (i + 1) / steps;
            const k = 1 - Math.exp(-u * rate);
            const y = flatY - k * (flatY - topY);
            const sx = x0 + i * stepW;
            (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, sx, y, 2.2, c.green, 0.15, 2.2);
        }
        // Traveling pulse along compiled staircase
        const prog = t * 0.26 % 1;
        const idx = Math.min(steps - 1, Math.floor(prog * steps));
        const u = (idx + 1) / steps;
        const py = flatY - (1 - Math.exp(-u * rate)) * (flatY - topY);
        const px = x0 + prog * (x1 - x0);
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, py, 4, c.green, 0.35, 3);
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "compiled", x1, topY + 6, c.green, c.bg, c.green, "right");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "stateless", x1, flatY - 16, c.red, c.bg, c.red, "right");
    });
}



function $1125e27b9b9e009a$export$ffb20dd0d312640(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    const pill = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxv-pill");
    const b0 = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn", "0");
    const b4 = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn", "4");
    const b15 = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn is-active", "15 gates");
    [
        b0,
        b4,
        b15
    ].forEach((b)=>b.type = "button");
    pill.append(b0, b4, b15);
    stage.append(pill);
    fig.prepend(stage);
    let gates = 15;
    const r = (0, $5c38d4c8775354e7$export$5c03d20f483e909a)(1010);
    const drops = Array.from({
        length: 28
    }, ()=>({
            x: 0.14 + r() * 0.72,
            y: r(),
            vy: 0.28 + r() * 0.22,
            bad: r() < 0.74,
            stopGate: Math.floor(r() * 15)
        }));
    const setGates = (n)=>{
        gates = n;
        b0.classList.toggle("is-active", n === 0);
        b4.classList.toggle("is-active", n === 4);
        b15.classList.toggle("is-active", n === 15);
    };
    b0.addEventListener("click", ()=>setGates(0));
    b4.addEventListener("click", ()=>setGates(4));
    b15.addEventListener("click", ()=>setGates(15));
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 215 : 240, (ctx, W, H, c, _t, dt)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        const padX = W * 0.12;
        const topY = 34;
        const botY = H - 28;
        const gateZoneH = botY - topY - 22;
        // Active horizontal laser gates
        for(let g = 0; g < 15; g++){
            const active = gates === 15 || gates === 4 && g % 4 === 0;
            if (!active) continue;
            const gy = topY + 12 + g / 14 * gateZoneH;
            ctx.strokeStyle = c.green;
            ctx.globalAlpha = 0.36;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(padX, gy);
            ctx.lineTo(W - padX, gy);
            ctx.stroke();
        }
        ctx.globalAlpha = 1;
        // Main branch baseline at bottom
        ctx.strokeStyle = c.tx;
        ctx.lineWidth = 2.2;
        ctx.beginPath();
        ctx.moveTo(padX, botY);
        ctx.lineTo(W - padX, botY);
        ctx.stroke();
        for (const d of drops){
            d.y += d.vy * dt * 0.65;
            if (d.y > 1) {
                d.y = 0;
                d.x = 0.14 + r() * 0.72;
                d.bad = r() < 0.74;
                d.stopGate = Math.floor(r() * 15);
            }
            const blocked = d.bad && (gates === 15 || gates === 4 && d.stopGate % 4 === 0);
            const stopY = blocked ? (topY + 12 + d.stopGate / 14 * gateZoneH) / H : botY / H;
            const px = d.x * W;
            const py = Math.min(d.y, stopY) * H;
            if (blocked && d.y >= stopY) {
                const age = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)((d.y - stopY) * 6);
                ctx.strokeStyle = c.red;
                ctx.globalAlpha = 1 - age;
                ctx.lineWidth = 1.5;
                const rad = 4 + age * 26;
                ctx.beginPath();
                ctx.arc(px, py, rad, 0, Math.PI * 2);
                ctx.stroke();
                ctx.globalAlpha = 1;
            } else {
                const col = d.bad ? c.red : c.green;
                ctx.fillStyle = col;
                ctx.globalAlpha = 0.25;
                ctx.fillRect(px - 1, py - 14, 2, 12);
                ctx.globalAlpha = 0.92;
                ctx.fillRect(px - 4.5, py - 2.5, 9, 5);
            }
        }
        ctx.globalAlpha = 1;
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "main", padX, botY - 14, c.tx, c.bg, c.ui, "left");
    });
}
function $1125e27b9b9e009a$export$e21d9c4d9fbdbf41(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const NODES = [
        {
            name: "mac",
            ang: -2.4
        },
        {
            name: "fedora",
            ang: -0.7
        },
        {
            name: "hetzner",
            ang: 0.7
        },
        {
            name: "av",
            ang: 2.4
        }
    ];
    let triggerNode = 1;
    let pulseT = 0;
    stage.style.cursor = "pointer";
    stage.addEventListener("click", ()=>{
        triggerNode = (triggerNode + 1) % NODES.length;
        pulseT = 0;
    });
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 215 : 240, (ctx, W, H, c, _t, dt)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        pulseT += dt * 0.85;
        if (pulseT > 2.2) {
            pulseT = 0;
            triggerNode = (triggerNode + 1) % NODES.length;
        }
        const cx = W * 0.5;
        const cy = H * 0.5;
        const rx = Math.min(195, W * 0.35);
        const ry = Math.min(72, H * 0.32);
        // Expanding green sync wave ring from central hub
        if (pulseT >= 0.8 && pulseT <= 1.9) {
            const u = (pulseT - 0.8) / 1.1;
            ctx.strokeStyle = c.green;
            ctx.globalAlpha = (1 - u) * 0.45;
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.ellipse(cx, cy, rx * u, ry * u, 0, 0, Math.PI * 2);
            ctx.stroke();
            ctx.globalAlpha = 1;
        }
        NODES.forEach((n, i)=>{
            const nx = cx + Math.cos(n.ang) * rx;
            const ny = cy + Math.sin(n.ang) * ry;
            ctx.strokeStyle = c.tx3;
            ctx.globalAlpha = 0.45;
            ctx.lineWidth = 1.4;
            ctx.setLineDash([
                3,
                3
            ]);
            ctx.beginPath();
            ctx.moveTo(cx, cy);
            ctx.lineTo(nx, ny);
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.globalAlpha = 1;
            // Phase 1 (0..0.8): Red error travels inward from triggerNode to hub
            if (i === triggerNode && pulseT < 0.8) {
                const u = pulseT / 0.8;
                const px = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(nx, cx, u);
                const py = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(ny, cy, u);
                (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, py, 4.5, c.red, 0.35, 3);
            }
            // Phase 2 (0.8..1.8): Green compiled rule broadcasts outward to all 4 hosts
            if (pulseT >= 0.8 && pulseT <= 1.8) {
                const u = (pulseT - 0.8) / 1.0;
                const px = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(cx, nx, u);
                const py = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(cy, ny, u);
                (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, py, 3.8, c.green, 0.3, 2.8);
            }
            const immunized = pulseT > 1.6;
            const nodeCol = immunized ? c.green : i === triggerNode && pulseT < 0.8 ? c.red : c.tx2;
            ctx.fillStyle = c.bg;
            ctx.strokeStyle = nodeCol;
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(nx, ny, 10, 0, Math.PI * 2);
            ctx.fill();
            ctx.stroke();
            (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, nx, ny, 3, nodeCol, immunized ? 0.25 : 0.1, 3);
            (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, n.name, nx, ny + (ny < cy ? -22 : 22), nodeCol, c.bg, c.ui, "center");
        });
        // Central tracequest hub
        const hubActive = pulseT >= 0.72 && pulseT <= 1.25;
        ctx.fillStyle = c.bg;
        ctx.strokeStyle = hubActive ? c.green : c.tx;
        ctx.lineWidth = 2.4;
        ctx.beginPath();
        ctx.arc(cx, cy, 17, 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, cx, cy, 4.5, hubActive ? c.green : c.tx, 0.25, 3);
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "tracequest", cx, cy + 32, c.tx, c.bg, c.ui, "center");
    });
}
function $1125e27b9b9e009a$export$ed24fb21aaeba579(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 205 : 230, (ctx, W, H, c, t)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        const x0 = 28;
        const slitX = W * 0.46;
        const gateX = W * 0.8;
        const midY = H * 0.54;
        // Left: 3 chaotic red traces converging on optical collimator slit
        for(let k = -1; k <= 1; k++){
            ctx.strokeStyle = c.red;
            ctx.globalAlpha = 0.75;
            ctx.lineWidth = 1.7;
            ctx.beginPath();
            const steps = 48;
            for(let i = 0; i <= steps; i++){
                const u = i / steps;
                const x = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(x0, slitX, u);
                const env = Math.pow(1 - u, 1.1);
                const y = midY + k * 44 * env + Math.sin(u * 15 - t * 3.4 + k * 2.1) * 15 * env;
                if (i === 0) ctx.moveTo(x, y);
                else ctx.lineTo(x, y);
            }
            ctx.stroke();
        }
        ctx.globalAlpha = 1;
        // Collimator slit jaws at slitX
        ctx.strokeStyle = c.tx;
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.moveTo(slitX, 26);
        ctx.lineTo(slitX, midY - 9);
        ctx.moveTo(slitX, midY + 9);
        ctx.lineTo(slitX, H - 22);
        ctx.stroke();
        // Middle: extracted invariant laser beam + glow
        ctx.strokeStyle = c.green;
        ctx.globalAlpha = 0.2;
        ctx.lineWidth = 7;
        ctx.beginPath();
        ctx.moveTo(slitX, midY);
        ctx.lineTo(gateX - 20, midY);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.lineWidth = 2.4;
        ctx.beginPath();
        ctx.moveTo(slitX, midY);
        ctx.lineTo(gateX - 20, midY);
        ctx.stroke();
        // Traveling coherent pulse
        const px = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(slitX, gateX - 20, t * 0.65 % 1);
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, px, midY, 3.2, c.green, 0.3, 2.8);
        // Right: crystalline gate block
        ctx.fillStyle = c.bg;
        ctx.strokeStyle = c.green;
        ctx.lineWidth = 2.2;
        ctx.beginPath();
        ctx.roundRect(gateX - 20, midY - 26, 40, 52, 5);
        ctx.fill();
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(gateX - 7, midY);
        ctx.lineTo(gateX - 1, midY + 6);
        ctx.lineTo(gateX + 9, midY - 6);
        ctx.stroke();
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "traces", (x0 + slitX) * 0.46, 20, c.red, c.bg, c.red, "center");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "invariant", (slitX + gateX) * 0.5, 20, c.tx2, c.bg, c.ui, "center");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "gate", gateX, midY + 42, c.green, c.bg, c.green, "center");
    });
}
function $1125e27b9b9e009a$export$cefd25b65a3343f(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    const pill = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxv-pill");
    const btn = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn", "compile");
    btn.type = "button";
    pill.append(btn);
    stage.append(pill);
    fig.prepend(stage);
    let compiled = false;
    const compSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0);
    const toggle = ()=>{
        compiled = !compiled;
        compSp.target = compiled ? 1 : 0;
        btn.classList.toggle("is-active", compiled);
    };
    stage.style.cursor = "pointer";
    stage.addEventListener("click", toggle);
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 215 : 240, (ctx, W, H, c, _t, dt)=>{
        const k = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(compSp.step(dt, 150, 18), 0, 1);
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        const cx = W * 0.5;
        const maxW = Math.min(360, W * 0.64);
        const botY = H - 24;
        for(let i = 0; i < 15; i++){
            const u = i / 14;
            const w = maxW * Math.pow(1 - u * 0.68, 0.85);
            const y = botY - (i + 1) * 9.5;
            const slide = k * ((i % 2 === 0 ? 1 : -1) * (W * 0.36));
            const alpha = 0.78 * (1 - k * 0.82);
            ctx.fillStyle = k > 0.5 ? c.green : c.tx3;
            ctx.globalAlpha = alpha;
            ctx.beginPath();
            ctx.roundRect(cx - w * 0.5 + slide, y, w, 7, 2);
            ctx.fill();
        }
        ctx.globalAlpha = 1;
        const capY = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(botY - 142.5 - 22, H * 0.48, k);
        const capW = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(68, 96, k);
        const capH = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(18, 26, k);
        ctx.fillStyle = c.green;
        ctx.globalAlpha = 0.18;
        ctx.beginPath();
        ctx.roundRect(cx - capW * 0.5 - 5, capY - 5, capW + 10, capH + 10, 6);
        ctx.fill();
        ctx.globalAlpha = 1;
        ctx.beginPath();
        ctx.roundRect(cx - capW * 0.5, capY, capW, capH, 4);
        ctx.fill();
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "10% taste", cx, capY - 14, c.green, c.bg, c.green, "center");
        if (k < 0.65) (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "90%", cx, botY - 68, c.tx, c.bg, c.ui, "center");
    });
}



function $16eb6b057a6c4c62$export$97b5073175692027(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    const pill = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fxv-pill");
    const b10 = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn is-active", "10:00");
    const b01 = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("button", "fxv-pill__btn", "01:00");
    b10.type = "button";
    b01.type = "button";
    pill.append(b10, b01);
    stage.append(pill);
    fig.prepend(stage);
    const r = (0, $5c38d4c8775354e7$export$5c03d20f483e909a)(1515);
    const lines = Array.from({
        length: 14
    }, (_, i)=>({
            indent: i % 3 * 14,
            w: 90 + r() * 220,
            fault: i === 6 || i === 10
        }));
    let tired = false;
    const kSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0);
    const setMode = (tMode)=>{
        tired = tMode;
        kSp.target = tMode ? 1 : 0;
        b10.classList.toggle("is-active", !tMode);
        b01.classList.toggle("is-active", tMode);
    };
    b10.addEventListener("click", ()=>setMode(false));
    b01.addEventListener("click", ()=>setMode(true));
    stage.style.cursor = "pointer";
    stage.addEventListener("click", (e)=>{
        if (e.target.closest("button")) return;
        setMode(!tired);
    });
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 210 : 235, (ctx, W, H, c, _t, dt)=>{
        const k = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(kSp.step(dt, 140, 18), 0, 1);
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        const padX = W * 0.14;
        // Top green CI banner (glows brighter at 01:00 as operator tunnel-visions on it)
        ctx.fillStyle = c.green;
        ctx.globalAlpha = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(0.14, 0.34, k);
        ctx.beginPath();
        ctx.roundRect(padX, 16, W - padX * 2, 24, 4);
        ctx.fill();
        ctx.strokeStyle = c.green;
        ctx.globalAlpha = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(0.45, 0.95, k);
        ctx.lineWidth = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(1, 2, k);
        ctx.stroke();
        ctx.globalAlpha = 1;
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "CI \u2713", padX + 10, 28, c.green, c.bg, c.green, "left");
        // 14 diff bars below
        lines.forEach((ln, i)=>{
            const y = 52 + i * 11.5;
            const x = padX + ln.indent;
            const bw = Math.min(ln.w, W - padX * 2 - ln.indent);
            if (ln.fault) {
                ctx.fillStyle = k > 0.6 ? c.tx3 : c.red;
                ctx.globalAlpha = (0, $5c38d4c8775354e7$export$3a89f8d6f6bf6c9f)(0.92, 0.14, k);
                ctx.fillRect(x, y, bw, 6);
                if (k < 0.8) (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, padX - 10, y + 3, 3, c.red, (1 - k) * 0.25, 2.6);
            } else {
                ctx.fillStyle = c.tx3;
                ctx.globalAlpha = 0.28 * (1 - k * 0.55);
                ctx.fillRect(x, y, bw, 5);
            }
        });
        ctx.globalAlpha = 1;
        if (k < 0.65) (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "faults", W - padX, 124, c.red, c.bg, c.red, "right");
    });
}
function $16eb6b057a6c4c62$export$27b965adb1bbc656(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const dipSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0.85);
    let userTouched = false;
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 210 : 235, (ctx, W, H, c, t, dt, pointer)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        if (pointer.inside) {
            userTouched = true;
            dipSp.target = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(pointer.y, 0.2, 1);
        } else if (!userTouched) dipSp.target = 0.38 + 0.54 * (0.5 + 0.5 * Math.sin(t * 0.75));
        const d = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(dipSp.step(dt, 160, 20), 0.15, 1);
        const x0 = 28;
        const x1 = W - 28;
        const w = x1 - x0;
        const topBase = H * 0.26;
        const botBase = H * 0.8;
        const dipX = 0.38;
        const spikeX = 0.74;
        const dxPx = x0 + dipX * w;
        const sxPx = x0 + spikeX * w;
        const dyPx = topBase + d * 48;
        const syPx = botBase - d * 68;
        // Phase-lag coupling vector between 01:00 dip and +48h spike
        ctx.strokeStyle = c.tx3;
        ctx.setLineDash([
            3,
            3
        ]);
        ctx.lineWidth = 1.2;
        ctx.beginPath();
        ctx.moveTo(dxPx, dyPx);
        ctx.lineTo(sxPx, syPx);
        ctx.stroke();
        ctx.setLineDash([]);
        // Top curve: operator focus
        ctx.strokeStyle = c.green;
        ctx.lineWidth = 2.2;
        ctx.beginPath();
        for(let i = 0; i <= 80; i++){
            const u = i / 80;
            const x = x0 + u * w;
            const g = Math.exp(-Math.pow((u - dipX) / 0.085, 2));
            const y = topBase + g * d * 48;
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
        }
        ctx.stroke();
        // Bottom curve: +48h revert rate with red area fill
        ctx.beginPath();
        for(let i = 0; i <= 80; i++){
            const u = i / 80;
            const x = x0 + u * w;
            const g = Math.exp(-Math.pow((u - spikeX) / 0.075, 2));
            const y = botBase - g * d * 68;
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
        }
        ctx.strokeStyle = c.red;
        ctx.lineWidth = 2.4;
        ctx.stroke();
        ctx.lineTo(x1, botBase);
        ctx.lineTo(x0, botBase);
        ctx.closePath();
        ctx.fillStyle = c.red;
        ctx.globalAlpha = 0.1;
        ctx.fill();
        ctx.globalAlpha = 1;
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, dxPx, dyPx, 4, c.green, 0.25, 2.8);
        (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, sxPx, syPx, 4.5, c.red, 0.35, 3);
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "focus", x0, topBase - 14, c.green, c.bg, c.green, "left");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "01:00", dxPx, dyPx + 18, c.tx2, c.bg, c.ui, "center");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "+48h reverts", sxPx, syPx - 16, c.red, c.bg, c.red, "center");
    });
    stage.style.cursor = "ns-resize";
}
function $16eb6b057a6c4c62$export$4f452a4c6fff8da3(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const pSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0.5);
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 215 : 240, (ctx, W, H, c, t, dt, pointer)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        pSp.target = pointer.inside ? pointer.x : (0, $5c38d4c8775354e7$export$d16895a5a96f4)(stage, 0.9, 0.2);
        const p = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(pSp.step(dt, 140, 20), 0, 1);
        const cx = W * 0.5;
        const cy = H * 0.5;
        const maxR = Math.min(88, H * 0.39);
        // Outer disk: compiled harness checks
        ctx.fillStyle = c.green;
        ctx.globalAlpha = 0.16;
        ctx.beginPath();
        ctx.arc(cx, cy, maxR, 0, Math.PI * 2);
        ctx.fill();
        ctx.globalAlpha = 1;
        ctx.strokeStyle = c.green;
        ctx.lineWidth = 2;
        ctx.stroke();
        // Radial shutter ticks on the compiled iris ring
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(t * 0.1 + p * 0.8);
        ctx.strokeStyle = c.green;
        ctx.globalAlpha = 0.35;
        ctx.lineWidth = 1;
        for(let a = 0; a < 24; a++){
            const ang = a / 24 * Math.PI * 2;
            ctx.beginPath();
            ctx.moveTo(Math.cos(ang) * (maxR - 8), Math.sin(ang) * (maxR - 8));
            ctx.lineTo(Math.cos(ang) * maxR, Math.sin(ang) * maxR);
            ctx.stroke();
        }
        ctx.restore();
        // Middle ring: uncompiled manual bug-catching (shrinks as p -> 1)
        const manR = maxR * (0.85 - p * 0.56);
        ctx.fillStyle = c.bg;
        ctx.beginPath();
        ctx.arc(cx, cy, manR, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = c.red;
        ctx.globalAlpha = 0.15;
        ctx.beginPath();
        ctx.arc(cx, cy, manR, 0, Math.PI * 2);
        ctx.fill();
        ctx.globalAlpha = 1;
        ctx.strokeStyle = c.red;
        ctx.setLineDash([
            3,
            3
        ]);
        ctx.lineWidth = 1.6;
        ctx.stroke();
        ctx.setLineDash([]);
        // Inner core: high-entropy human judgment ("you")
        const coreR = maxR * 0.25;
        ctx.fillStyle = c.tx;
        ctx.beginPath();
        ctx.arc(cx, cy, coreR, 0, Math.PI * 2);
        ctx.fill();
        ctx.font = `500 10px 'Geist Pixel', monospace`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = c.bg;
        ctx.fillText("you", cx, cy + 0.5);
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "checks", cx + maxR + 14, cy - maxR * 0.55, c.green, c.bg, c.green, "left");
        if (manR > coreR + 8) (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "manual", cx + manR + 12, cy + 16, c.red, c.bg, c.red, "left");
    });
    stage.style.cursor = "ew-resize";
}



function $542160bab774c767$export$f2e55ef171d26c77(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const r = (0, $5c38d4c8775354e7$export$5c03d20f483e909a)(1919);
    const items = Array.from({
        length: 12
    }, (_, i)=>({
            u: i / 12,
            speed: 0.24,
            veto: r() < 0.62
        }));
    const evalBezier = (u, p0, p1, p2, p3)=>{
        const inv = 1 - u;
        const b0 = inv * inv * inv;
        const b1 = 3 * inv * inv * u;
        const b2 = 3 * inv * u * u;
        const b3 = u * u * u;
        return [
            b0 * p0[0] + b1 * p1[0] + b2 * p2[0] + b3 * p3[0],
            b0 * p0[1] + b1 * p1[1] + b2 * p2[1] + b3 * p3[1]
        ];
    };
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 210 : 235, (ctx, W, H, c, _t, dt)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        const cx = W * 0.5;
        const topY = 16;
        const splitY = H * 0.34;
        const leftX = W * 0.25;
        const rightX = W * 0.75;
        const gateY = H * 0.66;
        const botY = H - 16;
        // Center mirror axis
        ctx.strokeStyle = c.tx3;
        ctx.globalAlpha = 0.4;
        ctx.setLineDash([
            3,
            4
        ]);
        ctx.beginPath();
        ctx.moveTo(cx, splitY);
        ctx.lineTo(cx, botY);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.globalAlpha = 1;
        // Smooth C1 guide tracks from top -> split -> gates -> deflection exits
        ctx.strokeStyle = c.ui;
        ctx.lineWidth = 1.2;
        ctx.beginPath();
        ctx.moveTo(cx, topY);
        ctx.lineTo(cx, splitY);
        [
            -1,
            1
        ].forEach((dir)=>{
            const gx = dir < 0 ? leftX : rightX;
            ctx.moveTo(cx, splitY);
            ctx.bezierCurveTo(cx, splitY + 34, gx, gateY - 38, gx, gateY);
            [
                -1,
                1
            ].forEach((branch)=>{
                const ex = gx + dir * branch * 34;
                ctx.moveTo(gx, gateY);
                ctx.bezierCurveTo(gx, gateY + 26, ex, botY - 22, ex, botY);
            });
        });
        ctx.stroke();
        // Track gate pulse intensity as particles pass smoothly through gateY
        let gatePulse = 0;
        for (const it of items){
            it.u = (it.u + it.speed * dt * 0.65) % 1;
            const u = it.u;
            const col = it.veto ? c.red : c.green;
            if (u < 0.28) {
                const s = u / 0.28;
                const y = topY + s * (splitY - topY);
                (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, cx, y, 3.2, c.tx2, 0.15, 2.2);
            } else if (u < 0.66) {
                // Segment 1: C1 cubic Bezier from (cx, splitY) into (gx, gateY) with vertical entry/exit tangents
                const s = (u - 0.28) / 0.38;
                const proximityToGate = Math.exp(-Math.pow((s - 0.96) / 0.16, 2));
                if (proximityToGate > gatePulse) gatePulse = proximityToGate;
                [
                    -1,
                    1
                ].forEach((dir)=>{
                    const gx = dir < 0 ? leftX : rightX;
                    const [x, y] = evalBezier(s, [
                        cx,
                        splitY
                    ], [
                        cx,
                        splitY + 34
                    ], [
                        gx,
                        gateY - 38
                    ], [
                        gx,
                        gateY
                    ]);
                    (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, x, y, 3.2 + proximityToGate * 0.8, s > 0.82 ? col : c.tx2, 0.15 + proximityToGate * 0.22, 2.6);
                });
            } else {
                // Segment 2: C1 cubic Bezier from (gx, gateY) out to deflected exit (ex, botY)
                const s = (u - 0.66) / 0.34;
                const proximityToGate = Math.exp(-Math.pow(s / 0.18, 2));
                if (proximityToGate > gatePulse) gatePulse = proximityToGate;
                [
                    -1,
                    1
                ].forEach((dir)=>{
                    const gx = dir < 0 ? leftX : rightX;
                    const ex = gx + dir * (it.veto ? -34 : 34);
                    const [x, y] = evalBezier(s, [
                        gx,
                        gateY
                    ], [
                        gx,
                        gateY + 26
                    ], [
                        ex,
                        botY - 22
                    ], [
                        ex,
                        botY
                    ]);
                    (0, $5c38d4c8775354e7$export$46dda4462911a727)(ctx, x, y, 3.3, col, 0.28 * (1 - s * 0.4), 2.7);
                });
            }
        }
        // Draw Left (you) and Right (clone) gate rings with subtle harmonic pulse on passage
        [
            leftX,
            rightX
        ].forEach((gx, idx)=>{
            const ringCol = idx === 0 ? c.tx : c.red;
            if (gatePulse > 0.05) {
                ctx.strokeStyle = ringCol;
                ctx.globalAlpha = gatePulse * 0.28;
                ctx.lineWidth = 4;
                ctx.beginPath();
                ctx.arc(gx, gateY, 17 + gatePulse * 3.5, 0, Math.PI * 2);
                ctx.stroke();
            }
            ctx.globalAlpha = 1;
            ctx.fillStyle = c.bg;
            ctx.strokeStyle = ringCol;
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(gx, gateY, 16, 0, Math.PI * 2);
            ctx.fill();
            ctx.stroke();
            // Inner reticle dot
            ctx.fillStyle = ringCol;
            ctx.globalAlpha = 0.25 + gatePulse * 0.45;
            ctx.beginPath();
            ctx.arc(gx, gateY, 3, 0, Math.PI * 2);
            ctx.fill();
            ctx.globalAlpha = 1;
        });
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "you", leftX, gateY + 34, c.tx, c.bg, c.ui, "center");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "clone \xb7 98%", rightX, gateY + 34, c.red, c.bg, c.red, "center");
    });
}
function $542160bab774c767$export$cd3d99778accc57e(fig) {
    const stage = (0, $5c38d4c8775354e7$export$dda1d9f60106f0e9)("div", "fx-figure__stage fxv");
    fig.prepend(stage);
    const r = (0, $5c38d4c8775354e7$export$5c03d20f483e909a)(2020);
    const pts = Array.from({
        length: 200
    }, ()=>({
            x: 0.06 + r() * 0.88,
            y: 0.08 + r() * 0.84
        }));
    const bendSp = (0, $5c38d4c8775354e7$export$d1f8fcb84651afa9)(0.52);
    let userMoved = false;
    (0, $5c38d4c8775354e7$export$a629db21b6497626)(stage, (w)=>w < 540 ? 215 : 240, (ctx, W, H, c, t, dt, pointer)=>{
        ctx.clearRect(0, 0, W, H);
        (0, $5c38d4c8775354e7$export$bb1011bf29bdb8a7)(ctx, W, H, c);
        if (pointer.inside) {
            userMoved = true;
            bendSp.target = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(1 - pointer.y, 0.15, 0.95);
        } else if (!userMoved) bendSp.target = 0.48 + Math.sin(t * 0.6) * 0.16;
        const b = (0, $5c38d4c8775354e7$export$7d15b64cf5a3a4c4)(bendSp.step(dt, 160, 20), 0.12, 0.98);
        const boundaryY = (nx)=>0.82 - b * 0.62 * Math.pow(nx, 1.2);
        // Shaded approval region above boundary
        ctx.beginPath();
        for(let i = 0; i <= 48; i++){
            const u = i / 48;
            const x = u * W;
            const y = boundaryY(u) * H;
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
        }
        ctx.lineTo(W, 0);
        ctx.lineTo(0, 0);
        ctx.closePath();
        ctx.fillStyle = c.green;
        ctx.globalAlpha = 0.08;
        ctx.fill();
        ctx.globalAlpha = 1;
        // 200 diff points classified by the live boundary
        for (const p of pts){
            const by = boundaryY(p.x);
            const approved = p.y < by;
            ctx.fillStyle = approved ? c.green : c.red;
            ctx.globalAlpha = approved ? 0.82 : 0.72;
            const px = p.x * W;
            const py = p.y * H;
            ctx.fillRect(px - 2, py - 2, 4, 4);
        }
        ctx.globalAlpha = 1;
        // Underglow + razor-sharp decision boundary curve
        ctx.strokeStyle = c.tx;
        ctx.globalAlpha = 0.16;
        ctx.lineWidth = 6;
        ctx.beginPath();
        for(let i = 0; i <= 48; i++){
            const u = i / 48;
            const x = u * W;
            const y = boundaryY(u) * H;
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
        }
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.lineWidth = 2.2;
        ctx.setLineDash([
            5,
            4
        ]);
        ctx.beginPath();
        for(let i = 0; i <= 48; i++){
            const u = i / 48;
            const x = u * W;
            const y = boundaryY(u) * H;
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
        }
        ctx.stroke();
        ctx.setLineDash([]);
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "accept", 18, 22, c.green, c.bg, c.green, "left");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "boundary", W - 18, boundaryY(0.88) * H - 14, c.tx, c.bg, c.ui, "right");
        (0, $5c38d4c8775354e7$export$7ac3698ce9457404)(ctx, "veto", W - 18, H - 20, c.red, c.bg, c.red, "right");
    });
    stage.style.cursor = "ns-resize";
}


// Inline effects (`<span data-fx>`) and scripted figures
// (`<figure class="fx-figure" data-figure>`) for blog posts.
const $21e5ad7e4b8f1d03$var$figures = {
    arbitrage: (0, $8646d2e2bbbd7e5f$export$1dc8de7c9cf5d13),
    bargain: (0, $8646d2e2bbbd7e5f$export$c10e76ebe093ee46),
    cut: (0, $b490805aa5bd5c06$export$f468e077dafd7866),
    divergent: (0, $97dcc32b9b6ba392$export$ee5e7d054da6f733),
    "retry-loop": (0, $97dcc32b9b6ba392$export$eed79ea19baf81a9),
    xray: (0, $ed5b5a7f3206661a$export$51dce08b3efe5596),
    flow: (0, $6a0c9221858f39e0$export$18c5b31298e7b8db),
    hillclimb: (0, $ed5b5a7f3206661a$export$d39a347e090d9af1),
    compounding: (0, $ed5b5a7f3206661a$export$a997277d1a38e7f8),
    sandbox: (0, $1125e27b9b9e009a$export$ffb20dd0d312640),
    topology: (0, $1125e27b9b9e009a$export$e21d9c4d9fbdbf41),
    clusters: (0, $d64e07c83f960d39$export$41850b5b35db191),
    anatomy: (0, $1125e27b9b9e009a$export$ed24fb21aaeba579),
    pareto: (0, $1125e27b9b9e009a$export$cefd25b65a3343f),
    recorder: (0, $16eb6b057a6c4c62$export$27b965adb1bbc656),
    "fatigue-diff": (0, $16eb6b057a6c4c62$export$97b5073175692027),
    surface: (0, $16eb6b057a6c4c62$export$4f452a4c6fff8da3),
    ladder: (0, $9dce61d788f521b3$export$27c9715a72c1f992),
    clone: (0, $542160bab774c767$export$f2e55ef171d26c77),
    "phase-space": (0, $542160bab774c767$export$cd3d99778accc57e)
};
function $21e5ad7e4b8f1d03$var$boot() {
    document.querySelectorAll(".fx-figure[data-figure]").forEach((fig)=>{
        const init = $21e5ad7e4b8f1d03$var$figures[fig.dataset.figure ?? ""];
        if (!init) {
            console.warn(`[post-fx] Unknown figure "${fig.dataset.figure}". Supported: ${Object.keys($21e5ad7e4b8f1d03$var$figures).join(", ")}.`);
            return;
        }
        fig.classList.add("is-live");
        init(fig);
    });
    (0, $d1367d94205577f3$export$5dd9ba22cea632f5)();
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $21e5ad7e4b8f1d03$var$boot, {
    once: true
});
else $21e5ad7e4b8f1d03$var$boot();


//# sourceMappingURL=index.5aaa4481.js.map
